// a banner - stub
class SnailyError extends Error {

    #metadata;

    constructor(message, metadata) {
        super(message);
        this.name = "SnailyError";
        this.#metadata = metadata;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SnailyError);
        }
    }

    get metadata() {
        return this.#metadata;
    }

    toString() {
        let result = `${super.toString()}; Metadata: ${JSON.stringify(this.#metadata)}`;
        return result;
    }

}

class ExtensionNotInstalledError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ExtensionNotInstalledError";

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ExtensionNotInstalledError);
        }
    }

    get skipLogging() {
        return true;
    }
}

const officialEmojiExpression = () => {
    // https://mths.be/emoji
    return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC08\uDC26](?:\u200D\u2B1B)?|[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};

class InvalidOperationError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "InvalidOperationError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InvalidOperationError);
        }
    }
    
}

class ArgumentNullError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ArgumentNullError";

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ArgumentNullError);
        }
    }

}

function toDateFromEpoch(epoch) {
    //let utcEpoch = epoch + 60 * 1000 * (new Date().getTimezoneOffset());
    //let result = new Date(utcEpoch);
    //return result;
    let result = new Date(epoch);
    return result;
}


const utils = (function () {
    function isJson(obj) {
        let result = obj && obj.constructor === {}.constructor;
        return result;
    }

    function cutFirstLine(source) {
        let result = source.substring(source.indexOf('\n') + 2);
        return result;
    }

    let monthAbbr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];

    function unifyHoursOrMinutes(source) {
        if (source < 10) {
            return `0${source}`;
        }

        return source;
    }

    function unofficialEmojiExpression() {
        return /[\u2388\u000e]/g;
    }

    function findClosingQuote(value, quoteStart) {
        let result = -1;
        let isEscaped = false;
        for (let i = quoteStart + 1; i < value.length; i++) {
            const ch = value[i];
            if (isEscaped) {
                isEscaped = false;
                continue;
            }

            switch (ch) {
                case '\\':
                    isEscaped = true;
                    continue;
                case '"':
                    result = i;
                    return result;
            }
        }

        return result;
    }

    function findObjectOrArrayEnd(value, jsonStart) {
        let result = -1;
        let depth = 0;
        let inString = false;
        let escapeNext = false;
        for (let i = jsonStart; i < value.length; i++) {
            const ch = value[i];
            if (escapeNext) {
                escapeNext = false;
                continue;
            }

            switch (ch) {
                case '\\':
                    escapeNext = true;
                    continue;
                case '"':
                    inString = !inString;
                    continue;
            }

            if (inString) {
                continue;
            }

            switch (ch) {
                case '[':
                case '{':
                    depth++;
                    break;
                case ']':
                case '}':
                    depth--;
                    if (depth === 0) {
                        result = i;
                        return result;
                    }
                    break;
            }
        }

        return result;
    }

    return {

        createTextTrackingId: function () {
            let array = new Uint8Array(16);
            let e = crypto.getRandomValues(array);
            let result = utils.pt(e);
            return result;
        },

        pt: function (e) {
            for (var t, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = [], i = 0, o = e.length, a = o % 3, s = o - a; i < s;)
                t = e[i] << 16,
                    t |= e[i + 1] << 8,
                    t |= e[i + 2],
                    r.push(n.charAt(t >>> 18 & 63)),
                    r.push(n.charAt(t >>> 12 & 63)),
                    r.push(n.charAt(t >>> 6 & 63)),
                    r.push(n.charAt(63 & t)),
                    i += 3;
            switch (a) {
                case 2:
                    t = e[i] << 16,
                        t |= e[i + 1] << 8,
                        r.push(n.charAt(t >>> 18 & 63)),
                        r.push(n.charAt(t >>> 12 & 63)),
                        r.push(n.charAt(t >>> 6 & 63)),
                        r.push("=");
                    break
                case 1:
                    t = e[i] << 16,
                        r.push(n.charAt(t >>> 18 & 63)),
                        r.push(n.charAt(t >>> 12 & 63)),
                        r.push("="),
                        r.push("=");
            }
            return r.join("")
        },

        toString: function (obj) {
            let result = "";
            if (obj instanceof Error) {
                do {
                    result += obj.stack;
                    if (obj.InnerError) {
                        obj = obj.InnerError;
                        result += "\n *** Inner error ***\n";
                    } else {
                        obj = null;
                    }
                } while (obj)
            } else if (isJson(obj)) {
                result = JSON.stringify(obj);
            } else {
                result = obj;
            }
            return result;
        },

        timeConverter: function (timestamp) {
            let unixTimeStamp = parseInt(timestamp);
            const result = new Date(unixTimeStamp).toLocaleString();
            return result;
        },

        isJson: isJson,

        isDefined: function (value) {
            let result = value !== null && value !== undefined;
            return result;
        },

        asObject: function (value) {
            let result = typeof value === 'object' && value !== null 
                ? value 
                : null;
            return result;
        },

        asArray: function (value) {
            let result = Array.isArray(value) 
                ? value 
                : null;
            return result;
        },

        isObject: function (value) {
            let result = value !== null && typeof value === 'object';
            return result;
        },

        cutFirstLine: cutFirstLine,

        randomUUID: function () {
            let result = crypto.randomUUID();
            return result;
        },

        getStackTrace: function () {
            let error = new Error();
            let withoutErrorLine = cutFirstLine(error.stack);
            let result = cutFirstLine(withoutErrorLine);
            return result;
        },

        isIterable: function (obj) {
            if (!obj) {
                return false;
            }

            const result = typeof obj[Symbol.iterator] === 'function';
            return result;
        },

        addDays: function (date, days) {
            let hours = 24;
            let minutes = 60;
            let seconds = 60;
            let dateEpoch = date.getTime() + days * hours * minutes * seconds * 1000;
            let result = new Date(dateEpoch);
            return result;
        },

        addMinutes: function (date, minutes) {
            let seconds = 60;
            let dateEpoch = date.getTime() + minutes * seconds * 1000;
            let result = new Date(dateEpoch);
            return result;
        },

        addSeconds: function (date, seconds) {
            let dateEpoch = date.getTime() + seconds * 1000;
            let result = new Date(dateEpoch);
            return result;
        },

        dateTimeToString(source) {
            let result = `${source.getDate()} ${monthAbbr[source.getMonth()]} ${source.getFullYear()} ${unifyHoursOrMinutes(source.getHours())}:${unifyHoursOrMinutes(source.getMinutes())}`;
            return result;
        },

        toDateFromIso8651(source) {
            let number = Date.parse(source);
            if (isNaN(number)) {
                return null;
            }

            let result = new Date(number);
            return result;
        },

        toDateFromEpoch(epoch) {
            let result = toDateFromEpoch(epoch);
            return result;
        },

        getCurrentDateTime() {
            let currentEpoch = Date.now();
            let result = toDateFromEpoch(currentEpoch);
            return result;
        },

        toEpochFromDate(date) {
            let result = date.getTime();
            return result;
        },

        clone(source) {
            let str = JSON.stringify(source);
            let result = JSON.parse(str);
            return result;
        },

        cutOffEmoji(input) {
            if (!input) {
                return input;
            }

            //let oldExpression = /\p{Emoji}+/gu;
            let result = input.replaceAll(officialEmojiExpression(), '')
                .replaceAll(unofficialEmojiExpression(), '');
            return result;
        },

        cutEdges(str) {
            if (str.length < 2) {
                throw new RangeError("Index and length must refer to a location within the string.");
            }
            const result = str.substring(1, str.length - 1);
            return result;
        },

        getChromeVersion() {
            try {
                let result = /Chrome\/([0-9.]+)/.exec(navigator.userAgent)[1];
                return result;
            } catch {
                return "<unknown>";
            }
        },

        base64ToArrayBuffer(base64) {
            var binaryString = atob(base64);
            var bytes = new Uint8Array(binaryString.length);
            for (var i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        },

        // brackets are not escaped by default  https://developer.mozilla.org/en-US/docs/web/javascript/reference/global_objects/encodeuricomponent
        // they must be escaped
        customEncodeUri(source) {
            let result = encodeURIComponent(source);
            result = result.replaceAll('(', '%28');
            result = result.replaceAll(')', '%29');
            return result;
        },

        customDecodeUri(source) {
            let result = decodeURIComponent(source);
            return result;
        },

        castToBoolean(variable, metadata) {
            if (typeof variable == "boolean") {
                return variable;
            } else if (variable === undefined) {
                return null;
            } else {
                throw new InvalidOperationError(`Variable is not boolean ${variable}`, metadata);
            }
        },

        getReferrer(url) {
            let result = url.toString()
                .replace(url.hash, '');
            return result;
        },

        single(source, metadata) {
            if (!source) {
                throw new ArgumentNullError("Source is null.", metadata);
            }
            if (source.length === 0) {
                throw new InvalidOperationError("The input sequence is empty.", metadata);
            }
            if (source.length > 1) {
                throw new InvalidOperationError("The input sequence contains more than one element.", metadata);
            }
            return source[0];
        },

        isEmptyObject(source) {
            if (!source) {
                return false;
            }

            const result = Object.getOwnPropertyNames(source).length === 0;
            return result;
        },

        findJsonEnd(value, jsonStart) {
            let result;
            if (value[jsonStart] === '"') {
                result = findClosingQuote(value, jsonStart);
                return result;
            }

            result = findObjectOrArrayEnd(value, jsonStart);
            return result;
        }
    };
})();

const metadataFactory = (function () {

    const factoryResult = {

        create: function () {
            let result = {
                correlationId: utils.randomUUID()
            };
            return result;
        }
    };

    return factoryResult;
})();

const backendTopics = {
    global: "global",
    tabMessage: "tabMessage",
    apiProxy: "apiProxy",
    linkedInProxyV2: "linkedInProxyV2",
    linkedInProxyHeaders: "linkedInProxyHeaders",
    linkedInService: "linkedInService",
    linkedInVoyagerSpy: "linkedInVoyagerSpy",
    linkedInHeadersRewriter: "linkedInHeadersRewriter",
    salesNavigatorProxy: "salesNavigatorProxy",
    salesNavigatorService: "salesNavigatorService",
    oauth: "oauth",
    logging: "logging",
    traceableRequests: "traceableRequests",
    scheduler: "scheduler",
    exportContacts: "exportContacts",
    system: "system",
    settings: "settings",
    localStorage: "localStorage",
    reliability: "reliability",
    campaignsRunner: "campaignsRunner",
    offscreen: "offscreen",
    cookies: "cookies"
};

const backendCommandsFactory = (function () {

    const factoryResult = {

        system: {

            createGetExtensionSettings: function (metadata) {
                let result = {
                    target: backendTopics.system,
                    command: "getExtensionSettings",
                    args: {
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            }
        },

        settings: {

            createGetApplicationsSettings: function (metadata) {
                let result = {
                    target: backendTopics.settings,
                    command: "getApplicationsSettings",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            }
        },

        apiProxy: {

            createCreateExportTag: function (name, type, exportMetadata, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "createExportTag",
                    args: {
                        parameter: {
                            name: name,
                            type: type,
                            metadata: exportMetadata
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createExportTaggedContacts: function (tagId, contacts, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "exportTaggedContacts",
                    args: {
                        parameter: {
                            tagId: tagId,
                            contacts: contacts
                        },
                        metadata: metadata
                    },
                };
                return result;
            },

            createAddMetadataToTag: function (tagId, exportMetadata, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "addMetadataToTag",
                    args: {
                        parameter: {
                            tagId: tagId,
                            metadata: exportMetadata
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSyncConversations: function (conversations, timestamp, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "syncConversations",
                    args: {
                        parameter: {
                            conversations: conversations,
                            timestamp: timestamp
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSyncConnections: function (connections, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "syncConnections",
                    args: {
                        parameter: {
                            connections: connections
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSyncContact: function (contactId, contact, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "syncContact",
                    args: {
                        parameter: {
                            contactId: contactId,
                            contact: contact
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetNextOperations: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getNextOperations",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetOperation: function (campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getOperation",
                    args: {
                        parameter: {
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetWithdrawOperations: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getWithdrawOperations",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createStepExecuted: function (campaignId, campaignExecutionId, stepNumber, actionResult, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepExecuted",
                    args: {
                        parameter: {
                            campaignId: campaignId,
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber,
                            actionResult: actionResult
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStepError: function (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepExecutionError",
                    args: {
                        parameter: {
                            campaignId: campaignId,
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStepSkipped: function (campaignId, campaignExecutionId, stepNumber, reason, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepSkipped",
                    args: {
                        parameter: {
                            campaignId: campaignId,
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber,
                            reason: reason
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStepWithdrawn: function (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepWithdrawn",
                    args: {
                        parameter: {
                            campaignId: campaignId,
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStepWithdrawError: function (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepWithdrawError",
                    args: {
                        parameter: {
                            campaignId: campaignId,
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createReportExceedLimit: function (operationType, code, campaignId, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "reportExceedLimit",
                    args: {
                        parameter: {
                            operationType: operationType,
                            code: code,
                            campaignId: campaignId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetMyProfile: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getMyProfile",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createAddLinkedInProfile: function (linkedInProfile, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "addLinkedInProfile",
                    args: {
                        parameter: {
                            linkedInProfile: linkedInProfile
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetLinkedInProfiles: function (metadata) {
                const result = {
                    target: backendTopics.apiProxy,
                    command: "getLinkedInProfiles",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetWorkingHours: function (preferTeamMemberHeaders, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getWorkingHours",
                    args: {
                        parameter: {
                            preferTeamMemberHeaders: preferTeamMemberHeaders
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSetRunningActivities: function (state, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "setRunningActivities",
                    args: {
                        parameter: {
                            state: state
                        },
                        metadata: metadata
                    }

                };
                return result;
            },

            createRefreshCampaignExecutions: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "refreshCampaignExecutions",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createEndAutomationRun: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "endAutomationRun",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createExchangeAuthorizationCode: function (code, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "exchangeAuthorizationCode",
                    args: {
                        parameter: {
                            code: code
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSwitchToWorkspace: function (linkedInProfileId, metadata) {
                const result = {
                    target: backendTopics.apiProxy,
                    command: "switchToWorkspace",
                    args: {
                        parameter: {
                            linkedInProfileId: linkedInProfileId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createRevokeToken: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "revokeToken",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetRecentExports: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getRecentExports",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createReportLogEntry: function (logEventId, severity, message, args, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "reportLogEntry",
                    args: {
                        parameter: {
                            logEventId: logEventId,
                            severity: severity,
                            message: message,
                            args: args
                        },
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createRefreshAuthTokens: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "refreshAuthTokens",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetAccessToken: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getAccessToken",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createIsCompatibleWithCurrentExtension: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "isCompatibleWithCurrentExtension",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createExtensionDetected: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "extensionDetected",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createSetWorkingHours: function (workingHours, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "setWorkingHours",
                    args: {
                        parameter: {
                            workingHours: workingHours
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSignInUnderTeamMember: function (personaId, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "signInUnderTeamMember",
                    args: {
                        parameter: {
                            personaId: personaId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSignOutUnderTeamMember: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "signOutUnderTeamMember",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetCurrentDateTime: function (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getCurrentDateTime",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createCreateLinkedInTrackingId: function (uuid, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "createLinkedInTrackingId",
                    args: {
                        parameter: {
                            uuid: uuid
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createReportCustomMessageTooLong: function (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "reportCustomMessageTooLong",
                    args: {
                        parameter: {
                            campaignId: campaignId,
                            campaignExecutionId: campaignExecutionId,
                            stepNumber: stepNumber
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            backendAutomation: {

                createSaveLinkedinHeaders: function (headers, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "saveLinkedinHeaders",
                        args: {
                            parameter: {
                                headers: headers
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetCurrentProfile: function (cookies, otherHeaders, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getCurrentLinkedInProfile",
                        args: {
                            parameter: {
                                cookies: cookies,
                                other: otherHeaders
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetLinkedInContactsFromSearchPage: function (searchRequest, referrer, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getLinkedInContactsFromSearchPage",
                        args: {
                            parameter: {
                                searchRequest: searchRequest,
                                referrer: referrer
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetLinkedInContactsFromMyConnections: function (start, count, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getLinkedInContactsFromMyConnections",
                        args: {
                            parameter: {
                                start: start,
                                count: count
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetLinkedInConnectionsCount: function (metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getLinkedInConnectionsCount",
                        args: {
                            parameter: {},
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetLinkedInContactsFromGroupPage: function (searchRequest, typeaheadQuery, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getLinkedInContactsFromGroupPage",
                        args: {
                            parameter: {
                                searchRequest: searchRequest,
                                typeaheadQuery: typeaheadQuery
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetSalesNavigatorContactsFromSearchPage: function (searchRequest, referer, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getSalesNavigatorContactsFromSearchPage",
                        args: {
                            parameter: {
                                searchRequest: searchRequest,
                                referer: referer
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetSalesNavigatorContactsFromLeadsList: function (searchRequest, referer, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getSalesNavigatorContactsFromLeadsList",
                        args: {
                            parameter: {
                                searchRequest: searchRequest,
                                referer: referer
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetContact: function (id, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getContact",
                        args: {
                            parameter: {
                                id: id
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                }
            }
        },

        linkedInProxy: {

            authorize: {
                V2: {

                    createTypeInConversation: function (conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "typeInConversation",
                            args: {
                                parameter: {
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactActions: function (id, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactActions",
                            args: {
                                parameter: {
                                    id: id,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConnections: function (start, count, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConnections",
                            args: {
                                parameter: {
                                    start: start,
                                    count: count,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConnectionsCount: function (publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConnectionsCount",
                            args: {
                                parameter: {
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetCurrentProfile: function (headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getCurrentProfile",
                            args: {
                                parameter: {
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationEventsByCursor: function (selfEntityId, conversationId, prevCursor, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationEventsByCursor",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    prevCursor: prevCursor,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createUnfollowContact: function (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "unfollowContact",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createFollowContactTopPosts: function (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "followContactTopPosts",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createFollowContactAllPosts: function (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "followContactAllPosts",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createWithdrawInvitation: function (invitationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "withdrawInvitation",
                            args: {
                                parameter: {
                                    invitationId: invitationId,
                                    headers: headers,
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactsFromSearchPage: function (parameters, start, referrer, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactsFromSearchPage",
                            args: {
                                parameter: {
                                    parameters: parameters,
                                    start: start,
                                    referrer: referrer,
                                    headers: headers,
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactsFromGroupPage: function (groupId, start, pageSize, typeaheadQuery, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactsFromGroupPage",
                            args: {
                                parameter: {
                                    groupId: groupId,
                                    start: start,
                                    pageSize: pageSize,
                                    typeaheadQuery: typeaheadQuery,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactLatestJobs: function (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactLatestJobs",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers,
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactMiniProfile: function (id, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactMiniProfile",
                            args: {
                                parameter: {
                                    id: id,
                                    headers: headers,
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createReactOnContactPost: function (postEntityId, postType, publicIdentifier, reaction, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "reactOnContactPost",
                            args: {
                                parameter: {
                                    postEntityId: postEntityId,
                                    postType: postType,
                                    publicIdentifier: publicIdentifier,
                                    reaction: reaction,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactRecentPosts: function (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactRecentPosts",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createCreateConversation: function (selfEntityId, recipientEntityId, message, attachmentsInfo, trackingId, recipientId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "createConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    recipientEntityId: recipientEntityId,
                                    message: message,
                                    trackingId: trackingId,
                                    recipientId: recipientId,
                                    attachmentsInfo: attachmentsInfo,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationsBy: function (parameters, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationsBy",
                            args: {
                                parameter: {
                                    parameters: parameters,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createCreateInvitation: function (entityId, message, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "createInvitation",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    message: message,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers,
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createCreateConversationEvent: function (
                        selfEntityId,
                        conversationId,
                        text,
                        trackingId,
                        replyTo,
                        attachmentsInfo,
                        headers,
                        metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "createConversationEvent",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    text: text,
                                    trackingId: trackingId,
                                    replyTo: replyTo,
                                    attachmentsInfo: attachmentsInfo,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationRecentEvents: function (selfEntityId, conversationId, deliveredAt, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationRecentEvents",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    deliveredAt: deliveredAt,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetFirstContactSkills: function (publicIdentifier, entityId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getFirstContactSkills",
                            args: {
                                parameter: {
                                    publicIdentifier: publicIdentifier,
                                    entityId: entityId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetNextContactSkills: function (listComponent, includeMetadata, start, count, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getNextContactSkills",
                            args: {
                                parameter: {
                                    listComponent: listComponent,
                                    includeMetadata: includeMetadata,
                                    start: start,
                                    count: count,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createEndorseContactSkill: function (publicIdentifier, profileEndorsedSkill, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "endorseContactSkill",
                            args: {
                                parameter: {
                                    publicIdentifier: publicIdentifier,
                                    profileEndorsedSkill: profileEndorsedSkill,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createVisitContactProfile: function (
                        publicIdentifier,
                        objectId,
                        networkDistance,
                        epoch,
                        applicationVersion,
                        interfaceLocale,
                        profileTrackingId,
                        pageInstanceTrackingId,
                        guid,
                        applicationTrackingId,
                        clientGlobalSequenceNumber,
                        theme,
                        uri,
                        headers,
                        metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "visitContactProfile",
                            args: {
                                parameter: {
                                    publicIdentifier: publicIdentifier,
                                    objectId: objectId,
                                    networkDistance: networkDistance,
                                    epoch: epoch,
                                    applicationVersion: applicationVersion,
                                    interfaceLocale: interfaceLocale,
                                    profileTrackingId: profileTrackingId,
                                    pageInstanceTrackingId: pageInstanceTrackingId,
                                    guid: guid,
                                    applicationTrackingId: applicationTrackingId,
                                    clientGlobalSequenceNumber: clientGlobalSequenceNumber,
                                    theme: theme,
                                    uri: uri,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactInfo: function (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactInfo",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    publicIdentifier: publicIdentifier,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetCompanyProfile: function (companyId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getCompanyProfile",
                            args: {
                                parameter: {
                                    companyId: companyId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationSeenReceipts: function (entityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationSeenReceipts",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetUnreadConversationCountsByMailbox: function (entityId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getUnreadConversationCountsByMailbox",
                            args: {
                                parameter: {
                                    entityId: entityId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetFeedUpdatePreview: function (urn, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getFeedUpdatePreview",
                            args: {
                                parameter: {
                                    urn: urn,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetContactsOutboundInvitations: function (start, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactsOutboundInvitations",
                            args: {
                                parameter: {
                                    start: start,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetOutboundInvitationsSummary: function (headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getOutboundInvitationsSummary",
                            args: {
                                parameter: {
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationParticipants: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationParticipants",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createRevokeConversationEventReaction: function (selfEntityId, conversationId, eventId, emoji, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "revokeConversationEventReaction",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    eventId: eventId,
                                    emoji: emoji,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createAddConversationEventReaction: function (selfEntityId, conversationId, eventId, emoji, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "addConversationEventReaction",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    eventId: eventId,
                                    emoji: emoji,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createDeclineConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "declineConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createAcceptConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "acceptConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createChangeConversationEvent: function (selfEntityId, conversationId, eventId, text, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "changeConversationEvent",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    eventId: eventId,
                                    text: text,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createDeleteConversationEvent: function (selfEntityId, conversationId, eventId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "deleteConversationEvent",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    eventId: eventId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createUnreadConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "unreadConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createReadConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "readConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createMoveConversationToFocusedMailbox: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "moveConversationToFocusedMailbox",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createMoveConversationToOtherMailbox: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "moveConversationToOtherMailbox",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createUnarchiveConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "unarchiveConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createArchiveConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "archiveConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createUnstarConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "unstarConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createStarConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "starConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createDeleteConversation: function (selfEntityId, conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "deleteConversation",
                            args: {
                                parameter: {
                                    selfEntityId: selfEntityId,
                                    conversationId: conversationId,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createGetMessagingSettings: function (headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getMessagingSettings",
                            args: {
                                parameter: {
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createUploadConversationAttachment: function (conversationId, uploadUrl, attachmentBytes, contentType, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "uploadConversationAttachment",
                            args: {
                                parameter: {
                                    conversationId: conversationId,
                                    uploadUrl: uploadUrl,
                                    attachmentBytes: attachmentBytes,
                                    contentType: contentType,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createBookConversationAttachment: function (conversationId, attachmentType, fileSize, fileName, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "bookConversationAttachment",
                            args: {
                                parameter: {
                                    conversationId: conversationId,
                                    attachmentType: attachmentType,
                                    fileSize: fileSize,
                                    fileName: fileName,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createDownloadConversationAttachment: function (attachmentUrl, conversationId, accept, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "downloadConversationAttachment",
                            args: {
                                parameter: {
                                    attachmentUrl: attachmentUrl,
                                    conversationId: conversationId,
                                    accept: accept,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    },

                    createAcknowledgedAboutMessageDelivery: function (conversationId, messageId, clientId, deliveryMechanism, clientConsumedAt, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "acknowledgedAboutMessageDelivery",
                            args: {
                                parameter: {
                                    conversationId: conversationId,
                                    messageId: messageId,
                                    clientId: clientId,
                                    deliveryMechanism: deliveryMechanism,
                                    clientConsumedAt: clientConsumedAt,
                                    headers: headers
                                },
                                metadata: metadata
                            }
                        };
                        return result;
                    }

                },
            },

            headers: {

                saveLinkedInHeaders: function (metadata) {
                    let result = {
                        target: backendTopics.linkedInProxyHeaders,
                        command: "saveLinkedInHeaders",
                        args: {
                            metadata: metadata
                        }
                    };
                    return result;
                }
            }

        },

        linkedInService: {

            createGetCurrentProfile: function (metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getCurrentProfile",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetContactsFromSearchPage: function (parameters, start, referrer, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactsFromSearchPage",
                    args: {
                        parameter: {
                            parameters: parameters,
                            start: start,
                            referrer: referrer
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetContactsFromGroupPage: function (groupId, start, pageSize, typeaheadQuery, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactsFromGroupPage",
                    args: {
                        parameter: {
                            groupId: groupId,
                            start: start,
                            pageSize: pageSize,
                            typeaheadQuery: typeaheadQuery
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetContactsFromConnections: function (start, count, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactsFromConnections",
                    args: {
                        parameter: {
                            start: start,
                            count: count
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createReadNewConnections: function (connectedAfter, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "readNewConnections",
                    args: {
                        parameter: {
                            connectedAfter: connectedAfter
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createReadNewConversations: function (createdAfter, createdBefore, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "readNewConversations",
                    args: {
                        parameter: {
                            createdAfter: createdAfter,
                            createdBefore: createdBefore
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSendMessage: function (publicIdentifier, entityId, text, attachments, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "sendMessage",
                    args: {
                        parameter: {
                            publicIdentifier: publicIdentifier,
                            entityId: entityId,
                            text: text,
                            attachments: attachments
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createConnect: function (publicIdentifier, entityId, message, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "connect",
                    args: {
                        parameter: {
                            publicIdentifier: publicIdentifier,
                            entityId: entityId,
                            message: message
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createWithdraw: function (invitationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "withdraw",
                    args: {
                        parameter: {
                            invitationId: invitationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetContactFullProfile: function (id, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactFullProfile",
                    args: {
                        parameter: {
                            id: id
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createFollow: function (publicIdentifier, entityId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "follow",
                    args: {
                        parameter: {
                            publicIdentifier: publicIdentifier,
                            entityId: entityId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createReactOnRecentContactPost: function (publicIdentifier, entityId, reaction, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "reactOnRecentContactPost",
                    args: {
                        parameter: {
                            publicIdentifier: publicIdentifier,
                            entityId: entityId,
                            reaction: reaction
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createEndorseMostPopularContactSkill: function (publicIdentifier, entityId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "endorseMostPopularContactSkill",
                    args: {
                        parameter: {
                            publicIdentifier: publicIdentifier,
                            entityId: entityId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createNormalize: function (miniProfile, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "normalize",
                    args: {
                        parameter: {
                            miniProfile: miniProfile
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createUploadConversationAttachment: function (conversationId, attachment, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "uploadConversationAttachment",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            attachment: attachment
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetMessagingSettings: function (metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getMessagingSettings",
                    args: {
                        parameter: {},
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetConversations: function (parameters, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getConversations",
                    args: {
                        parameter: parameters,
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetConversationRecentEvents: function (conversationId, deliveredAt, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getConversationRecentEvents",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            deliveredAt: deliveredAt
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetConversationEventsByCursor: function (conversationId, prevCursor, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getConversationEventsByCursor",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            prevCursor: prevCursor
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createWithdrawContactsOutboundInvitations: function (count, isAscending, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "withdrawContactsOutboundInvitations",
                    args: {
                        parameter: {
                            count: count,
                            isAscending: isAscending
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createSaveUnreadConversationsCounters: function (metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "saveUnreadConversationsCounters",
                    args: {
                        parameter: {},
                        metadata: metadata
                    }
                };
                return result;
            },

            createDownloadConversationAttachment: function (conversationId, attachmentUrl, accept, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "downloadConversationAttachment",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            attachmentUrl: attachmentUrl,
                            accept: accept
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createDeleteConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "deleteConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createDeleteConversationEvent: function (conversationId, eventId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "deleteConversationEvent",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            eventId: eventId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStarConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "starConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createUnstarConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "unstarConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createArchiveConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "archiveConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createUnarchiveConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "unarchiveConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createMoveConversationToOtherMailbox: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "moveConversationToOtherMailbox",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createMoveConversationToFocusedMailbox: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "moveConversationToFocusedMailbox",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createReadConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "readConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createUnreadConversation: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "unreadConversation",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createChangeConversationEvent: function (conversationId, eventId, text, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "changeConversationEvent",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            eventId: eventId,
                            text: text
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createCreateConversationEvent: function (conversationId, text, attachments, replyTo, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "createConversationEvent",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            text: text,
                            attachments: attachments,
                            replyTo: replyTo
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createAddConversationEventReaction: function (conversationId, eventId, emoji, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "addConversationEventReaction",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            eventId: eventId,
                            emoji: emoji
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createRevokeConversationEventReaction: function (conversationId, eventId, emoji, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "revokeConversationEventReaction",
                    args: {
                        parameter: {
                            conversationId: conversationId,
                            eventId: eventId,
                            emoji: emoji
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetConversationParticipants: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getConversationParticipants",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetConversationSeenReceipts: function (conversationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getConversationSeenReceipts",
                    args: {
                        parameter: {
                            conversationId: conversationId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createVisitContactProfile: function (id, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "visitContactProfile",
                    args: {
                        parameter: {
                            id: id
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

        },

        linkedInVoyagerSpy: {

            createResetCache: function (metadata) {
                let result = {
                    target: backendTopics.linkedInVoyagerSpy,
                    command: "resetCache",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            }
        },

        linkedInHeadersRewriter: {

            createSetReferer: function (referrer, metadata) {
                let result = {
                    target: backendTopics.linkedInHeadersRewriter,
                    command: "setReferer",
                    args: {
                        parameter: {
                            referrer: referrer
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createResetReferer: function (metadata) {
                let result = {
                    target: backendTopics.linkedInHeadersRewriter,
                    command: "resetReferer",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            }

        },

        salesNavigatorProxy: {

            authorize: {

                createGetContactsFromSearchPage: function (searchRequest, referer, headers, metadata) {
                    let result = {
                        target: backendTopics.salesNavigatorProxy,
                        command: "getContactsFromSearchPage",
                        args: {
                            parameter: {
                                searchRequest: searchRequest,
                                referer: referer,
                                headers: headers
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createGetContactsFromLeadsList: function (searchRequest, referer, headers, metadata) {
                    let result = {
                        target: backendTopics.salesNavigatorProxy,
                        command: "getContactsFromLeadsList",
                        args: {
                            parameter: {
                                searchRequest: searchRequest,
                                referer: referer,
                                headers: headers
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createCreateInMailConversationByEntityUrn: function (entityUrn, subject, message, trackingId, headers, metadata) {
                    let result = {
                        target: backendTopics.salesNavigatorProxy,
                        command: "createInMailConversationByEntityUrn",
                        args: {
                            parameter: {
                                entityUrn: entityUrn,
                                subject: subject,
                                message: message,
                                trackingId: trackingId,
                                headers: headers
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                },

                createCreateInMailConversationByConversationId: function (conversationId, message, trackingId, headers, metadata) {
                    let result = {
                        target: backendTopics.salesNavigatorProxy,
                        command: "createInMailConversationByConversationId",
                        args: {
                            parameter: {
                                conversationId: conversationId,
                                message: message,
                                trackingId: trackingId,
                                headers: headers
                            },
                            metadata: metadata
                        }
                    };
                    return result;
                }

            }

        },

        salesNavigatorService: {

            createGetContactsFromSearchPage: function (searchRequest, referer, metadata) {
                let result = {
                    target: backendTopics.salesNavigatorService,
                    command: "getContactsFromSearchPage",
                    args: {
                        parameter: {
                            searchRequest: searchRequest,
                            referer: referer
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetContactsFromLeadsList: function (searchRequest, referer, metadata) {
                let result = {
                    target: backendTopics.salesNavigatorService,
                    command: "getContactsFromLeadsList",
                    args: {
                        parameter: {
                            searchRequest: searchRequest,
                            referer: referer
                        },
                        metadata: metadata
                    }
                };
                return result;
            },
        },

        auth: {

            createSignOut: function (metadata) {
                let result = {
                    target: backendTopics.oauth,
                    command: "signOut",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetSignInUri: function (state, referrer, metadata) {
                let result = {
                    target: backendTopics.oauth,
                    command: "getSigninUri",
                    args: {
                        parameter: {
                            state: state,
                            referrer: referrer,
                        },
                        metadata: metadata
                    }
                };
                return result;
            }

        },

        localStorage: {

            createGetSnailyProfile: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSnailyProfile",
                    args: {
                        metadata: metadata,
                        checkSignedInLinkedInUser: true
                    }
                };
                return result;
            },

            createGetLatestKnownSnailyProfile: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getLatestKnownSnailyProfile",
                    args: {
                        metadata: metadata,
                        checkSignedInLinkedInUser: false
                    }
                };
                return result;
            },

            createGetUserLogLevel: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getUserLogLevel",
                    args: {
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createGetLinkedInProfile: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getLinkedInProfile",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetSignedInPersonaJwtTokens: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSignedInPersonaJwtTokens",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetSignedInLinkedInUser: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSignedInLinkedInUser",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createSaveSignedInPersonaJwtTokens: function (jwtTokens, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveSignedInPersonaJwtTokens",
                    args: {
                        parameter: {
                            jwtTokens: jwtTokens
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createDeleteSignedInPersonaJwtTokens: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "deleteSignedInPersonaJwtTokens",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetImpersonatedPersonaJwtTokens: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getImpersonatedPersonaJwtTokens",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createSaveImpersonatedPersonaJwtTokens: function (jwtTokens, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveImpersonatedPersonaJwtTokens",
                    args: {
                        parameter: {
                            jwtTokens: jwtTokens
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createDeleteImpersonatedPersonaJwtTokens: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "deleteImpersonatedPersonaJwtTokens",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetPendingCommands: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getPendingCommands",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createSavePendingCommands: function (commands, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "savePendingCommands",
                    args: {
                        parameter: {
                            commands: commands
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createDeletePendingCommands: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "deletePendingCommands",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetLinkedInHeaders: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getLinkedInHeaders",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createSaveLinkedInHeaders: function (headers, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveLinkedInHeaders",
                    args: {
                        parameter: {
                            headers: headers
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetSalesNavigatorHeaders: function (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSalesNavigatorHeaders",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createSaveSalesNavigatorHeaders: function (headers, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveSalesNavigatorHeaders",
                    args: {
                        parameter: {
                            headers: headers
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

        },

        cookies: {
            
            createGetLinkedInCookies: function (metadata) {
                let result = {
                    target: backendTopics.cookies,
                    command: "getLinkedInCookies",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

        },

        automation: {

            createGetExportState: function (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "getState",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createStartCsvExport: function (type, publicIdentifiers, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "start",
                    args: {
                        parameter: {
                            type: type,
                            details: {
                                publicIdentifiers: publicIdentifiers
                            }
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStartCsvContactsExport: function (type, contacts, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "start",
                    args: {
                        parameter: {
                            type: type,
                            details: {
                                contacts: contacts
                            }
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStartExportContactsFromUrl: function (tag, type, url, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "start",
                    args: {
                        parameter: {
                            type: type,
                            details: {
                                url: url,
                                tag: tag
                            }
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createStopExport: function (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "stop",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createClearExport: function (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "clear",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createGetExportHref: function (exportId, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "getExportHref",
                    args: {
                        parameter: {
                            exportId: exportId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createCountProfilesInLinkedInSearch: function (url, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "countProfilesInLinkedInSearch",
                    args: {
                        parameter: {
                            url: url
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createCountProfilesInLinkedInGroup: function (url, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "countProfilesInLinkedInGroup",
                    args: {
                        parameter: {
                            url: url
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createCountProfilesInSalesNavigatorSearch: function (url, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "countProfilesInSalesNavigatorSearch",
                    args: {
                        parameter: {
                            url: url
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createCountProfilesInLinkedInMyConnections: function (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "countProfilesInLinkedInMyConnections",
                    args: {
                        parameter: {},
                        metadata: metadata
                    }
                };
                return result;
            },

            createCountProfilesInSalesNavigatorLeadsList: function (url, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "countProfilesInSalesNavigatorLeadsList",
                    args: {
                        parameter: {
                            url: url
                        },
                        metadata: metadata
                    }
                };
                return result;
            }

        },

        browser: {

            createGetTabInfo: function (tabId, metadata) {
                let result = {
                    target: backendTopics.global,
                    command: 'getTabInfoAsync',
                    args: {
                        parameter: {
                            tabId: tabId
                        },
                        metadata: metadata
                    }
                };
                return result;
            },

            createTabMessage: function (tabId, message, metadata) {
                let result = {
                    target: backendTopics.tabMessage,
                    command: "sendMessage",
                    args: {
                        parameter: {
                            tabId: tabId,
                            message: message
                        },
                        metadata: metadata
                    }
                };
                return result;
            }
        },

        logging: {

            createLogError: function (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logError",
                    args: {
                        parameter: {
                            logEntryId: logEntryId,
                            parameters: parameters
                        },
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createLogTrace: function (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logTrace",
                    args: {
                        parameter: {
                            logEntryId: logEntryId,
                            parameters: parameters
                        },
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createLogInformation: function (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logInformation",
                    args: {
                        parameter: {
                            logEntryId: logEntryId,
                            parameters: parameters
                        },
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createLogWaring: function (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logWarning",
                    args: {
                        parameter: {
                            logEntryId: logEntryId,
                            parameters: parameters
                        },
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            }
        },

        traceable: {

            createHttpRequest: function (uri, requestInit, metadata) {
                let result = {
                    target: backendTopics.traceableRequests,
                    command: "httpRequest",
                    args: {
                        parameter: {
                            uri: uri,
                            requestInit: requestInit
                        },
                        metadata: metadata
                    },
                    skipTracing: true
                };
                return result;
            }

        },

        reliability: {

            createResendPendingCommandsIfAny: function (metadata) {
                let result = {
                    target: backendTopics.reliability,
                    command: "resendPendingCommandsIfAny",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createReliablePublish: function (command, metadata) {
                let result = {
                    target: backendTopics.reliability,
                    command: "reliablePublish",
                    args: {
                        parameter: {
                            command: command
                        },
                        metadata: metadata
                    }
                };
                return result;
            }
        },

        campaignsRunner: {

            createIsInWorkingHours: function (metadata) {
                let result = {
                    target: backendTopics.campaignsRunner,
                    command: "isInWorkingHours",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },
        },

        // these commands are needed only in development
        offScreen: {

            isUpdateAvailable: function (metadata) {
                let result = {
                    target: backendTopics.offscreen,
                    command: "isUpdateAvailable",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },

            createUpdateAvailable: function (metadata) {
                let result = {
                    target: backendTopics.offscreen,
                    command: "updateAvailable",
                    args: {
                        metadata: metadata
                    }
                };
                return result;
            },
        }
    };

    return factoryResult;

})();

class ExtensionRuntimeError extends SnailyError {

    constructor(message, request, metadata) {
        super(message, request, metadata);
        this.name = "ExtensionRuntimeError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ExtensionRuntimeError);
        }
    }

    toString() {
        let result = `${super.toString()}; Request: ${JSON.stringify(this.request)}`;
        return result;
    }
}

/**
 * This error happens when there is no handler for a message.
 * It could happens when popup is closed and backendBroker fires an event.
 */
class MissingReceiverExtensionRuntimeError extends ExtensionRuntimeError {

    constructor(message, request, metadata) {
        super(message, request, metadata);
        this.name = "MissingReceiverExtensionRuntimeError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MissingReceiverExtensionRuntimeError);
        }
    }

    get skipLogging() {
        return true;
    }
}

/**
 * This error happens when handler ends execution before sendResponse is called.
 * It is most likely improper implementation , see details https://developer.chrome.com/docs/extensions/mv2/messaging/
 */

class PortClosedExtensionRuntimeError extends ExtensionRuntimeError {

    constructor(message, request, metadata) {
        super(message, request, metadata);
        this.name = "PortClosedExtensionRuntimeError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PortClosedExtensionRuntimeError);
        }
    }

    get skipLogging() {
        return true;
    }
}

const runtimeErrorsFactory = (function () {

    const factory = {

        create: function (message, stackTrace, request, metadata) {
            let result;
            if (message === "Could not establish connection. Receiving end does not exist.") {
                result = new MissingReceiverExtensionRuntimeError(message, request, metadata);
            } else if (message === "The message port closed before a response was received.") {
                result = new PortClosedExtensionRuntimeError(message, request, metadata);
            } else {
                result = new ExtensionRuntimeError(message, request, metadata);
            }

            if (stackTrace) {
                result.stack += `\n Inner async invocation \n ${stackTrace} \n`;
            }
            return result;
        }
    };
    return factory;

})();

class BadGatewayError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "BadGatewayError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BadGatewayError);
        }
    }

    get skipLogging() {
        return true;
    }

}

class NotAuthenticatedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NotAuthenticatedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotAuthenticatedError);
        }
    }

}

class NotAuthorizedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NotAuthorizedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotAuthorizedError);
        }
    }

}

class BadRequestError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "BadRequestError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BadRequestError);
        }
    }

}

class ProxyAuthenticationRequiredError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ProxyAuthenticationRequiredError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProxyAuthenticationRequiredError);
        }
    }

}

class UnprocessableEntityError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "UnprocessableEntityError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnprocessableEntityError);
        }
    }

}

class EmptySearchPageError extends SnailyError {

    constructor(response, metadata) {
        super(response.statusText, metadata);
        this.name = "EmptySearchPageError";
        this.url = response.url;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, EmptySearchPageError);
        }
    }
}

class OldExtensionError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "OldExtensionError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OldExtensionError);
        }
    }

}

class SnailySignInRequiredError extends SnailyError {

    constructor(body, metadata) {
        super(body, metadata);
        this.name = "SnailySignInRequiredError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SnailySignInRequiredError);
        }
    }

}

class LinkedInSignInRequiredError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "LinkedInSignInRequiredError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, LinkedInSignInRequiredError);
        }
    }

}

class LinkedInProfileAlreadyUsedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "LinkedInProfileAlreadyUsedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, LinkedInProfileAlreadyUsedError);
        }
    }

    get skipLogging() {
        return true;
    }

}

class LinkedInError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "LinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, LinkedInError);
        }
    }

}

class ExceedsLimitLinkedInError extends LinkedInError {

    #code;

    constructor(message, code, metadata) {
        super(message, metadata);
        this.name = "ExceedsLimitLinkedInError";
        this.#code = code;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ExceedsLimitLinkedInError);
        }
    }

    get Code() {
        return this.#code;
    }

}

class SalesNavigatorNotAuthorizedError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "SalesNavigatorNotAuthorizedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SalesNavigatorNotAuthorizedError);
        }
    }

}

class ProxyUnavailableError extends BadGatewayError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ProxyUnavailableError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProxyUnavailableError);
        }
    }

}

const errorsFactory = (function () {

    const result = {

        create: function (input, innerStackTrace, metadata) {

            let result;
            switch (input.name) {

                case 'BadGatewayError':
                    result = new BadGatewayError(input.message, metadata);
                    break;

                case 'NotAuthenticatedError':
                    result = new NotAuthenticatedError(input.message, metadata);
                    break;

                case 'NotAuthorizedError':
                    result = new NotAuthorizedError(input.message, metadata);
                    break;

                case 'SalesNavigatorNotAuthorizedError':
                    result = new SalesNavigatorNotAuthorizedError(input.message, metadata);
                    break;
                    
                case 'BadRequestError':
                    result = new BadRequestError(input.message, metadata);
                    break;

                case 'ProxyAuthenticationRequiredError':
                    result = new ProxyAuthenticationRequiredError(input.message, metadata);
                    break;

                case 'UnprocessableEntityError':
                    result = new UnprocessableEntityError(input.message, metadata);
                    break;

                case 'EmptySearchPageError':
                    result = new EmptySearchPageError(input.message, metadata);
                    break;

                case 'MissingReceiverExtensionRuntimeError':
                    result = new MissingReceiverExtensionRuntimeError(input.message, metadata);
                    break;

                case 'PortClosedExtensionRuntimeError':
                    result = new PortClosedExtensionRuntimeError(input.message, metadata);
                    break;

                case 'ExtensionRuntimeError':
                    result = new ExtensionRuntimeError(input.message, metadata);
                    break;

                case 'OldExtensionError':
                    result = new OldExtensionError(input.message, metadata);
                    break;

                case 'SnailySignInRequiredError':
                    result = new SnailySignInRequiredError(input.message, metadata);
                    break;

                case 'LinkedInSignInRequiredError':
                    result = new LinkedInSignInRequiredError(input.message, metadata);
                    break;

                case 'LinkedInProfileAlreadyUsedError':
                    result = new LinkedInProfileAlreadyUsedError(input.message, metadata);
                    break;
                    
                case 'ExceedsLimitLinkedInError':
                    result = new ExceedsLimitLinkedInError(input.message, metadata);
                    break;

                case 'ProxyUnavailableError':
                    result = new ProxyUnavailableError(input.message, metadata);
                    break;

                default:
                    result = new InvalidOperationError(input.message, metadata);
            }

            result.stack += `\n Original invocation ${input.stack}\n`;
            if (innerStackTrace) {
                result.stack += `\n Inner async invocation \n ${innerStackTrace} \n`;
            }

            return result;
        },

    };
    return result;

})();

class SnailyPromise extends Promise {

    constructor(callback) {
        let temp = {};
        Error.captureStackTrace(temp, SnailyPromise);
        const stackTrace = utils.cutFirstLine(temp.stack);

        const wrappedCallback = function (resolve, reject) {
            try {
                callback(resolve, function (e) {
                    if (utils.isJson(e)) {
                        if (e.stack) {
                            e.stack = e.stack + "\n" + stackTrace + "\n";
                        } else {
                            e.stack = stackTrace;
                        }
                    }
                    reject(e);
                });
            } catch (exp) {
                //ToDo;
                throw exp;
            }
        };
        super(wrappedCallback);
    }

    catch(...args) {
        let data = super.catch(...args);
        return data;
    }
}

class ClientError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ClientError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ClientError);
        }
    }
}

class ChromeRuntimeAdapter {

    constructor() {
    }

    async sendMessage(command) {
        let innerStackTrace = utils.getStackTrace();
        const result = await new SnailyPromise(function (resolve, reject) {
            try {
                chrome.runtime.sendMessage(
                    command,
                    function (response) {
                        let error;
                        if (chrome.runtime.lastError) {
                            error = runtimeErrorsFactory.create(chrome.runtime.lastError.message, innerStackTrace, command, command.args.metadata);
                            reject(error);
                            //need to distinguish null and  undefined
                        } else if (response) {
                            //ToDo: might be something more explicit
                            if (response.error) {
                                error = errorsFactory.create(response.error, innerStackTrace, command.args.metadata);
                                reject(error);
                            } else {
                                resolve(response);
                            }
                        } else {
                            resolve(null);
                        }
                    });
            } catch (exp) {
                //this could happens when extension is reloaded
                const error = runtimeErrorsFactory.create(exp.message, innerStackTrace, command, command.args.metadata);
                reject(error);
            }
        });
        return result;
    }

    async sendTabMessage(args) {
        let innerStackTrace = utils.getStackTrace();
        const result = await new SnailyPromise(function (resolve, reject) {
            try {
                chrome.tabs.sendMessage(args.parameter.tabId,
                    args.parameter.message,
                    function (response) {
                        //need to distinguish null and  undefined
                        if (!chrome.runtime.lastError) {
                            //ToDo: might be something more explicit
                            if (response && response.error) {

                                const innerError = new Error(response.error.message);
                                innerError.stack = response.error.stack;
                                let errorMessage = utils.toString(innerError);

                                let clientError = new ClientError(errorMessage, args, args.metadata);
                                clientError.stack += `\n Inner Error \n ${innerStackTrace} \n`;
                                reject(clientError);

                            } else {
                                resolve(response);
                            }
                        } else {
                            let error = runtimeErrorsFactory.create(chrome.runtime.lastError.message, innerStackTrace, args, args.metadata);
                            reject(error);
                        }
                    });
            } catch (exp) {
                //this could happens when extension is reloaded
                const error = runtimeErrorsFactory.create(exp.message, innerStackTrace, args, args.metadata);
                reject(error);
            }
        });
        return result;
    }

    async sendExtensionMessage(extensionId, message) {
        let innerStackTrace = utils.getStackTrace();
        const result = await new SnailyPromise(function (resolve, reject) {
            try {
                chrome.runtime.sendMessage(
                    extensionId,
                    message,
                    function (response) {
                        let error;
                        if (chrome.runtime.lastError) {
                            error = runtimeErrorsFactory.create(chrome.runtime.lastError.message, innerStackTrace, message, message.args.metadata);
                            reject(error);
                            //need to distinguish null and  undefined
                        } else if (response !== undefined && response !== null) {
                            //ToDo: might be something more explicit
                            if (response.error) {
                                error = errorsFactory.create(response.error, innerStackTrace, message.args.metadata);
                                reject(error);
                            } else {
                                resolve(response);
                            }
                        } else {
                            resolve(null);
                        }
                    });
            } catch (exp) {
                //this could happens when extension is reloaded
                const error = runtimeErrorsFactory.create(exp.message, innerStackTrace, message, message.args.metadata);
                reject(error);
            }
        });
        return result;
    }

    async createTab(url) {
        let tabInfo = {
            url: url
        };
        let result = await new SnailyPromise(function (resolve) {
            chrome.tabs.create(tabInfo,
                function (tab) {
                    resolve(tab);
                });
        });
        return result;
    }

    async clearAlarm(name) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.alarms.clear(name,
                function (wasCleared) {
                    resolve(wasCleared);
                });
        });
        return result;
    }

    async getAlarm(name) {
        const result = await new SnailyPromise(function (resolve) {
            chrome.alarms.get(name,
                function (alarm) {
                    resolve(alarm);
                });
        });
        return result;
    }

    async getSelectedTab() {
        let queryOptions = {active: true, lastFocusedWindow: true};
        // `tab` will either be a `tabs.Tab` instance or `undefined`.
        let [tab] = await chrome.tabs.query(queryOptions);
        return tab;
    }

    async getTab(id) {
        const result = await new SnailyPromise(function (resolve) {
            chrome.tabs.get(id,
                function (tab) {
                    resolve(tab);
                });
        });
        return result;
    }

    async reloadTab(id) {
        await new SnailyPromise(function (resolve) {
            chrome.tabs.reload(id, {}, resolve);
        });
    }

    async queryTabs() {
        let result = await new SnailyPromise(function (resolve) {
            chrome.tabs.query({},
                function (tabs) {
                    resolve(tabs);
                });
        });
        return result;
    }

    async createAlarm(name, delayInMinutes, periodInMinutes) {
        let alarmInfo = {delayInMinutes: delayInMinutes, periodInMinutes: periodInMinutes};
        await chrome.alarms.create(name, alarmInfo);
    }

    async createNotification(notificationId, options) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.notifications.create(notificationId,
                options,
                function (id) {
                    resolve(id);
                });
        });
        return result;
    }

    async setIcon(path) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.action.setIcon({path: path},
                function () {
                    resolve();
                });
        });
        return result;
    }

    async setBadgeText(text) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.action.setBadgeText({text: text},
                function () {
                    resolve();
                });
        });
        return result;
    }

    async setBadgeBackgroundColor(color) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.action.setBadgeBackgroundColor({color: color},
                function () {
                    resolve();
                });
        });
        return result;
    }

    async getProxyConfig() {
        let result = await new SnailyPromise(function (resolve) {
            chrome.proxy.settings.get({'incognito': false},
                function (config) {
                    resolve(config);
                });
        });
        return result;
    }

    async setProxyConfig(proxyConfig) {
        await new SnailyPromise(function (resolve) {
            chrome.proxy.settings.set(
                {value: proxyConfig, scope: 'regular'}, () => {
                    resolve();
                });
        });
    }

    async clearProxyConfig() {
        await new SnailyPromise(function (resolve) {
            chrome.proxy.settings.clear({scope: 'regular'},
                function () {
                    resolve();
                });
        });
    }

    reload() {
        chrome.runtime.reload();
    }

    addOnMessageListener(listener) {
        chrome.runtime.onMessage.addListener(listener);
    }

    addOnExternalMessageListener(listener) {
        chrome.runtime.onMessageExternal.addListener(listener);
    }

    addAlarmListener(listener) {
        chrome.alarms.onAlarm.addListener(listener);
    }

    addOnInstalledListener(listener) {
        chrome.runtime.onInstalled.addListener(listener);
    }

    addOnStartupListener(listener) {
        chrome.runtime.onStartup.addListener(listener);
    }

    addOnTabRemovedListener(listener) {
        chrome.tabs.onRemoved.addListener(listener);
    }

    addOnTabCreatedListener(listener) {
        chrome.tabs.onCreated.addListener(listener);
    }

    addOnTabReplacedListener(listener) {
        chrome.tabs.onReplaced.addListener(listener);
    }

    addOnTabUpdatedListener(listener) {
        chrome.tabs.onUpdated.addListener(listener);
    }

    addOnWebRequestBeforeSendHeadersListener(listener, urls, options) {
        chrome.webRequest.onBeforeSendHeaders.addListener(listener, {urls: urls}, options);
    }

    addOnWebRequestCompletedListener(listener, urls, options) {
        chrome.webRequest.onCompleted.addListener(listener, {urls: urls}, options);
    }

    addOnWebRequestBeforeRedirectListener(listener, urls, options) {
        chrome.webRequest.onBeforeRedirect.addListener(listener, {urls: urls}, options);
    }

    addOnWebRequestErrorOccurredListener(listener, urls, options) {
        chrome.webRequest.onErrorOccurred.addListener(listener, {urls: urls}, options);
    }

    addOnNotificationButtonClickedListener(listener) {
        chrome.notifications.onButtonClicked.addListener(listener);
    }

    addOnNotificationClickedListener(listener) {
        chrome.notifications.onClicked.addListener(listener);
    }

    addOnUpdateAvailableListener(listener) {
        chrome.runtime.onUpdateAvailable.addListener(listener);
    }

    addOnProxyErrorListener(listener) {
        chrome.proxy.onProxyError.addListener(listener);
    }

    removeOnProxyErrorListener(listener) {
        chrome.proxy.onProxyError.removeListener(listener);
    }

    addOnAuthRequiredListener(listener, urls, options) {
        chrome.webRequest.onAuthRequired.addListener(listener, {urls: urls}, options);
    }

    removeOnAuthRequiredListener(listener) {
        chrome.webRequest.onAuthRequired.removeListener(listener);
    }

    getName() {
        let result = chrome.runtime
            .getManifest()
            .name;
        return result;
    }

    getVersion() {
        let result = chrome.runtime
            .getManifest()
            .version;
        return result;
    }

    getId() {
        let result = chrome.runtime
            .id;
        return result;
    }

    async getLocalStorageItemAsync(key) {
        let storageItem = await chrome.storage.local.get([key]);
        let result = storageItem[key]
            ? storageItem[key]
            : null;
        return result;
    }

    async setLocalStorageItemAsync(key, value) {
        const json = {};
        json[key] = value;
        await chrome.storage.local.set(json);
    }

    async removeLocalStorageItemAsync(key) {
        await chrome.storage.local.remove(key);
    }

    async powerRequestSystemKeepAwake() {
        await chrome.power.requestKeepAwake("system");
    }

    async getAllCookies() {
        let details = {
            domain: "linkedin.com",
        };
        let result = await new SnailyPromise(function (resolve) {
            chrome.cookies.getAll(details, function (response) {
                resolve(response);
            });
        });
        return result;
    }

    async geCookies(name) {
        let details = {
            url: "https://www.linkedin.com",
            name: name
        };
        let result = await new SnailyPromise(function (resolve) {
            chrome.cookies.get(details, function (response) {
                resolve(response);
            });
        });
        return result;
    }
}

var runtimeAdapterFactory = function () {
    let result = new ChromeRuntimeAdapter();
    return result;
};

const eventNames = {
    exportStarting: 'exportStarting',
    exportStarted: 'exportStarted',
    exportCleared: 'exportCleared',
    exportChanged: 'exportChanged',
    exportFailed: 'exportFailed',
    exportCompleting: 'exportCompleting',
    exportCompleted: 'exportCompleted',
    snailySignedIn: 'snailySignedIn',
    snailySignedOut: 'snailySignedOut',
    snailyProfileChanged: 'snailyProfileChanged',
    linkedInSignedOut: 'linkedInSignedOut',
    linkedInProfileDetected: 'linkedInProfileDetected',
    automationScheduleTriggered: 'automationScheduleTriggered',
    automationScheduleDeleted: 'automationScheduleDeleted',
    automationScheduleCreated: 'automationScheduleCreated',
    automationEnded:'automationUpdated',
    extensionUpdating:"extensionUpdating",
    workingHoursChanged:"workingHoursChanged"
};

const logEntryIds = {
    unhandledError: 'ExtensionUnhandledError',
    exportError: 'ExtensionExportError',
    exportStopped: 'ExtensionExportStopped',
    runExecutionsError: "ExtensionRunExecutionsError",
    backendBrokerError: "ExtensionBackendBrokerError",

    linkedInSignedOut: "LinkedInSignedOut",
    linkedInProfileDetected: "LinkedInProfileDetected",
    automationScheduleCreated: "AutomationScheduleCreated",
    automationScheduleDeleted: "AutomationScheduleDeleted",
    automationScheduleTriggered: "AutomationScheduleTriggered",
    automationUnexpectedlyStopped: "AutomationUnexpectedlyStopped",
    extensionUpdating: "ExtensionUpdating",
    traceRequest: "TraceRequest",
    traceRequestError: "TraceRequestError",
    clusterSearch: "ClusterSearch",
    emojiTracing: "EmojiTracing",
    incompleteJobTracing: "IncompleteJobTracing",
    notSupportedResponse: "NotSupportedResponse",
    noPosts: "NoPosts",
    extensionProxyError: "ExtensionProxyError",
    extensionStarted: "ExtensionStarted",
    cannotParsePremiumBadge: "CannotParsePremiumBadge",
    allPostsAlreadyLiked: "AllPostsAlreadyLiked",
    cannotParseAvatarError: "CannotParseAvatarError",
    failToParseRestOfTheContactInfo: "FailToParseRestOfTheContactInfo",
    dataFetchSuppressed: "DataFetchSuppressed",
    notSupportedConversationCategoryType: "NotSupportedConversationCategoryType",
    notSupportedFeedUpdateContentComponent: "NotSupportedFeedUpdateContentComponent",
    unknownInvitationType: "UnknownInvitationType",
    unknownConversationState: "UnknownConversationState",
    unknownRenderFormat: "UnknownRenderFormat",
    notSupportedHostUrnData: "NotSupportedHostUrnData",
    notSupportedRenderContent: "NotSupportedRenderContent",
    conversationLastEventSenderNotFound: "ConversationLastEventSenderNotFound",
    companyNameGroomed: "CompanyNameGroomed",
    notFoundFocusedInboxEnabled: "NotFoundFocusedInboxEnabled",
    cannotFindCompanyProfile: "CannotFindCompanyProfile",
    acknowledgedMessageDeliveryException: "AcknowledgedMessageDeliveryException",
    cannotLoadLatestJobs: "CannotLoadLatestJobs",
    tabNotFound: "TabNotFound",

    //linkedIn
    xliTrackInvalidFormatError: "XliTrackInvalidFormatError",

    //trace logs
    eventFired: "ExtensionEventFired",
    commandStarted: "ExtensionCommandStarted",
    commandEnded: "ExtensionCommandEnded"
};

const errorParametersFactory = (function () {

    const result = {
        create: function (error, event) {
            let parameters = {};
            if (error instanceof Error) {
                parameters.Message = error.message
                    ? `${error.name}: ${error.message}`
                    : error.name;
                parameters.StackTrace = utils.toString(error);
            } else {
                parameters.Message = utils.toString(error);
            }
            if (event) {
                error.event = event;
            }

            return parameters;
        }
    };

    return result;
})();

const MailboxType = {
    Inbox: "Inbox",
    Focused: "Focused",
    Other: "Other"
};

const config = (function () {

    return {
        oauth: {
            client_id: "app.snaily.io",
            client_secret: "953944335FC24118B2674ECDCBBE1898",
            access_token_uri: "https://api.snaily.io/api/v1/auth/token",
            signin_uri: "https://auth.snaily.io/account/login",
            redirect_uri: "https://app.snaily.io/auth_callback"
        },
        backend: {
            api_endpoint: "https://api.snaily.io/",
            automation_endpoint: "https://automation.snaily.io/"
        },
        app: {
            imported_profiles_url_template: "https://app.snaily.io/contacts/import/{{import_id}}",
            post_sign_in_url: "https://app.snaily.io/referrer/web-store",
            home_url: "https://app.snaily.io/",
            support_url: "https://snaily.io/support",
            renew_subscription_url: "https://app.snaily.io/upgrade",
            bag_gateway_url: "https://developer.mozilla.org/ru/docs/Web/HTTP/Status/502",
            webstore_extension_url: "https://chrome.google.com/webstore/search/Snaily?hl=en"
        },
        linkedin: {
            home_url: "https://www.linkedin.com/",
            linkedin_search_people_url: "https://www.linkedin.com/search/results/people/",
            sales_navigator_search_people_url: "https://www.linkedin.com/sales/search/people",
            search_people_help_url: "https://www.linkedin.com/help/linkedin/answer/3544/searching-for-people-on-linkedin?lang=en"
        },
        integration: {
            linkedInUrlPattern: "www.linkedin.com/*",
            appUrlPattern: "https:\/\/app.snaily.io*"
        },
        extension: {
            name: "Snaily",
            reloadTabsOnStartUp: false
        }
    }
})();

class NotFoundError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NotFoundError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotFoundError);
        }
    }

}

const consoleLogger = (function () {

    let _version = null;
    if (chrome?.runtime?.getManifest) {
        _version = runtimeAdapterFactory().getVersion();
    } else {
        _version = "unknown";
    }

    function logMessage(message, callback) {
        const stringMessage = utils.toString(message);
        let finalMessage = `version-${_version}; ${stringMessage}`;
        callback(finalMessage);
    }

    return {

        info: function (message) {
            logMessage(message, console.info);
        },

        trace: function (message) {
            logMessage(message, console.trace);
        },

        warn: function (message) {
            logMessage(message, console.warn);
        },

        error: function (message) {
            logMessage(message, console.error);
        }

    };
})();

const backendBroker = (function () {

    const _subscribers = {};
    const _eventSubscriptions = {};
    const _runtime = runtimeAdapterFactory();

    async function logTrace(logEntryId, parameters, metadata) {
        let command = backendCommandsFactory.logging.createLogTrace(logEntryId, parameters, metadata);
        await publish(command);
    }

    function subscribeToEvent(eventName, handler) {
        if (!_eventSubscriptions[eventName]) {
            _eventSubscriptions[eventName] = [];
        }

        _eventSubscriptions[eventName].push(handler);
    }

    function unsubscribeFromEvent(eventName, handler) {
        if (!_eventSubscriptions[eventName]) {
            _eventSubscriptions[eventName] = [];
        }

        let index = _eventSubscriptions[eventName].indexOf(handler);
        if (index > -1) {
            _eventSubscriptions.slice(index, 1);
        }
    }

    async function fireEvent(event) {
        // noinspection ES6MissingAwait
        logTrace(logEntryIds.eventFired, {event: event.event}, event.args.metadata);

        let eventHandlers = _eventSubscriptions[event.event];
        if (eventHandlers) {
            for (const handler of eventHandlers) {
                // noinspection ES6MissingAwait
                broadcastBackendEvent(handler, event);
            }
        }

        // Send message outside of the  broker. Mainly it is needed for popup controller or app
        // noinspection ES6MissingAwait
        broadcastEventOutOfBroker(event);
    }

    async function broadcastBackendEvent(handler, event) {
        try {
            await handler(event.args);
        } catch (error) {
            if (error instanceof ExtensionRuntimeError || error.skipLogging) {
                return;
            }

            let parameters = errorParametersFactory.create(error, event);
            let message = backendCommandsFactory.logging.createLogError(logEntryIds.unhandledError, parameters, event.args.metadata);
            await safePublish(message);
        }
    }

    async function broadcastEventOutOfBroker(event) {
        try {
            await _runtime.sendMessage(event);
        } catch (error) {
            if (error instanceof ExtensionRuntimeError || error.skipLogging) {
                return;
            }

            let parameters = errorParametersFactory.create(error, event);
            let message = backendCommandsFactory.logging.createLogError(logEntryIds.unhandledError, parameters, event.args.metadata);
            await safePublish(message);
        }
    }

    function subscribeForCommands(topic, handler) {
        _subscribers[topic] = handler;
    }

    function unsubscribe(topic) {
        delete _subscribers[topic];
    }

    async function safePublish(request) {
        try {
            if (!request.skipTracing) {
                await logTrace(logEntryIds.commandStarted, {command: request}, request.args.metadata);
            } else {
                consoleLogger.trace(request);
            }

            let result = await publish(request);

            if (!request.skipTracing) {
                await logTrace(logEntryIds.commandEnded, {command: request}, request.args.metadata);
            } else {
                consoleLogger.trace(request);
            }

            return result;

        } catch (error) {
            if (error instanceof NotAuthenticatedError ||
                error instanceof NotAuthorizedError ||
                error instanceof NotFoundError ||
                error instanceof OldExtensionError ||
                error instanceof LinkedInSignInRequiredError ||
                error instanceof LinkedInError ||
                error instanceof LinkedInProfileAlreadyUsedError ||
                error instanceof ExtensionRuntimeError ||
                error instanceof SnailySignInRequiredError ||
                error.skipLogging ||
                request.skipTracing) ; else {

                let parameters = errorParametersFactory.create(error);
                parameters.command = request;
                let message = backendCommandsFactory.logging.createLogInformation(logEntryIds.backendBrokerError, parameters, request.args.metadata);
                await publish(message);
            }

            throw error;
        }
    }

    async function publish(request) {
        const targetModule = _subscribers[request.target];
        if (targetModule) {
            if (request.command) {
                if (!targetModule[request.command]) {
                    throw new InvalidOperationError(`There is no handler for ${request.command} at module - ${request.target}.`, request.args.metadata);
                }
                const result = await targetModule[request.command](request.args);
                return result;
            } else if (request.event) {

                if (targetModule[request.event]) {
                    await targetModule[request.event](request.args);
                }

                return null;
            } else {
                throw new InvalidOperationError(`Message ${JSON.stringify(request)} is not a command or event.`, request.args.metadata);
            }
        } else {
            throw new InvalidOperationError(`There is no handler for ${utils.toString(request)}`, request.args.metadata);
        }
    }


    // noinspection JSUnusedGlobalSymbols
    const moduleResult = {
        subscribeForCommands: subscribeForCommands,
        unsubscribe: unsubscribe,
        publish: safePublish,
        //:ToDo: workaround
        sendMessage: safePublish,
        subscribeToEvent: subscribeToEvent,
        unsubscribeFromEvent: unsubscribeFromEvent,
        fireEvent: fireEvent
    };
    return moduleResult;

})();

class ServerError extends SnailyError {

    #skipLogging;

    constructor(message, metadata, skipLogging = false) {
        super(message, metadata);
        this.name = "ServerError";
        this.#skipLogging = skipLogging;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ServerError);
        }
    }

    get skipLogging() {
        return this.#skipLogging;
    }
}

class MethodNotAllowedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "MethodNotAllowedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MethodNotAllowedError);
        }
    }

}

const repositoryErrorHandler = (function () {

    async function guard(response, metadata) {
        if (!response.ok) {
            let message = await response.text();
            switch (response.status) {
                case 500:
                    throw new ServerError(message, metadata);
                case 502:
                case 503:
                case 504:
                    throw new BadGatewayError("Bad network or service is temporarily unavailable. Please, try again later.", metadata);
                case 400:
                    throw new BadRequestError(message, metadata);
                case 401:
                    throw new NotAuthenticatedError(message, metadata);
                case 403:
                    throw new NotAuthorizedError(message, metadata);
                case 404:
                    throw new NotFoundError(message, metadata);
                case 405:
                    throw new MethodNotAllowedError(message, metadata);
                case 407:
                    throw new ProxyAuthenticationRequiredError(message, metadata);
                case 422:
                    throw new UnprocessableEntityError(message, metadata);
                default:
                    const error = {
                        status: response.status,
                        statusText: response.statusText,
                        body: message
                    };
                    let messageError = JSON.stringify(error);
                    throw new InvalidOperationError(messageError, metadata);
            }
        }
    }

    const result = {

        guard: guard

    };
    return result;

})();

const apiErrorHandler = (function () {

    async function guard(response, metadata) {
        if (!response.ok) {
            let message = await response.text();
            switch (response.status) {
                case 500:
                    throw new ServerError(message, metadata, true);

                default:
                    await repositoryErrorHandler.guard(response, metadata);
            }
        }
    }

    const result = {

        guard: guard

    };
    return result;

})();

var backendEventsFactory = (function () {

    const factoryResult = {

        createExportStarted: function (state, metadata) {
            let result = {
                event: eventNames.exportStarted,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createExportStarting: function (state, metadata) {
            let result = {
                event: eventNames.exportStarting,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createExportChanged: function (state, metadata) {
            let result = {
                event: eventNames.exportChanged,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createExportFailed: function (state, metadata) {
            let result = {
                event: eventNames.exportFailed,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createExportCompleting: function (state, metadata) {
            let result = {
                event: eventNames.exportCompleting,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createExportCompleted: function (state, metadata) {
            let result = {
                event: eventNames.exportCompleted,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createExportCleared: function (state, metadata) {
            let result = {
                event: eventNames.exportCleared,
                args: {
                    parameter: state,
                    metadata: metadata
                }
            };
            return result;
        },

        createSnailySignedIn: function (metadata) {
            let result = {
                event: eventNames.snailySignedIn,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createSnailySignedOut: function (metadata) {
            let result = {
                event: eventNames.snailySignedOut,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createSnailyProfileChanged: function (metadata) {
            let result = {
                event: eventNames.snailyProfileChanged,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createLinkedInSignedOut: function (reason, details, metadata) {
            let result = {
                event: eventNames.linkedInSignedOut,
                args: {
                    parameter: {
                        reason: reason,
                        details: details
                    },
                    metadata: metadata
                }
            };
            return result;
        },

        createLinkedInProfileDetected: function (linkedInProfile, metadata) {
            let result = {
                event: eventNames.linkedInProfileDetected,
                args: {
                    metadata: metadata,
                    parameter: {
                        linkedInProfile: linkedInProfile
                    }
                }
            };
            return result;
        },

        createAutomationScheduleTriggered: function (name, metadata) {
            let result = {
                event: eventNames.automationScheduleTriggered,
                args: {
                    parameter: {
                        name: name
                    },
                    metadata: metadata
                }
            };
            return result;
        },

        createAutomationScheduleDeleted: function (metadata) {
            let result = {
                event: eventNames.automationScheduleDeleted,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createAutomationScheduleCreated: function (metadata) {
            let result = {
                event: eventNames.automationScheduleCreated,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createAutomationEnded: function (metadata) {
            let result = {
                event: eventNames.automationEnded,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createExtensionUpdating: function (metadata) {
            let result = {
                event: eventNames.extensionUpdating,
                args: {
                    metadata: metadata
                }
            };
            return result;
        },

        createWorkingHoursChanged: function (metadata) {
            let result = {
                event: eventNames.workingHoursChanged,
                args: {
                    metadata: metadata
                }
            };
            return result;
        }

    };

    return factoryResult;

})();

function e(e){this.message=e;}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw "Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e;}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=true===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";

class InvalidHeaderError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "InvalidHeaderError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InvalidHeaderError);
        }
    }

}

const fetchErrorInterpreter = (function () {

    function interpreter(requestInit, error, metadata) {
        if (error instanceof TypeError && error.message === 'Failed to fetch') {
            throw new BadGatewayError("Bad network or service is temporarily is unavailable. Please, try again later.", metadata);
        }

        if (error instanceof TypeError && error.message.includes("String contains non ISO-8859-1 code point")) {
            let message = error.message + "; " + JSON.stringify(requestInit.headers);
            throw new InvalidHeaderError(message, metadata);
        }

        throw error;
    }

    const result = {

        interpreter: interpreter

    };
    return result;

})();

class HttpResponse {

    #response;
    #text = null;
    #blob = null;
    #requestInit = null;
    #metadata = null;

    constructor(requestInit, response, metadata) {
        this.#requestInit = requestInit;
        this.#response = response;
        this.#metadata = metadata;
    }

    async #readResponseIfNeeded() {
        if (!this.#response.bodyUsed) {
            this.#blob = await this.#response.blob();
            this.#text = await this.#blob.text();
        }
    }

    async text() {
        try {
            await this.#readResponseIfNeeded();
            return this.#text;
        } catch (error) {
            fetchErrorInterpreter.interpreter(this.#requestInit, error, this.#metadata);
        }
    }

    async json() {
        try {
            await this.#readResponseIfNeeded();
            let result = JSON.parse(this.#text);
            return result;
        } catch (error) {
            fetchErrorInterpreter.interpreter(this.#requestInit, error, this.#metadata);
        }
    }

    async blob() {
        try {
            await this.#readResponseIfNeeded();
            return this.#blob;
        } catch (error) {
            fetchErrorInterpreter.interpreter(this.#requestInit, error, this.#metadata);
        }
    }

    get ok() {
        return this.#response.ok;
    }

    get status() {
        return this.#response.status;
    }

    get statusText() {
        return this.#response.statusText;
    }

    get headers() {
        return this.#response.headers;
    }

}

async function httpRequest(url, requestInit, metadata) {
    try {
        let response = await fetch(url, requestInit);
        let result = new HttpResponse(requestInit, response);
        return result;
    } catch (error) {
        fetchErrorInterpreter.interpreter(requestInit, error, metadata);
    }
}

class NullResponseError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NullResponseError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NullResponseError);
        }
    }

}

class IncompleteReferenceDataError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "IncompleteReferenceDataError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, IncompleteReferenceDataError);
        }
    }

}

class MissingContactActionsError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "MissingContactActionsError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MissingContactActionsError);
        }
    }

}

class SendingDuplicateMessage extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "SendingDuplicateMessage";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SendingDuplicateMessage);
        }
    }

}

class MessageIsUnavailableLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "MessageIsUnavailableLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MessageIsUnavailableLinkedInError);
        }
    }

}

class MessageTemporarilyUnavailableLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "MessageTemporarilyUnavailableLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MessageTemporarilyUnavailableLinkedInError);
        }
    }

}

class NotSupportedResponseError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NotSupportedResponseError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotSupportedResponseError);
        }
    }

}

class ConnectTemporarilyUnavailableLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ConnectTemporarilyUnavailableLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ConnectTemporarilyUnavailableLinkedInError);
        }
    }

}

class EmailRequiredLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "EmailRequiredLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, EmailRequiredLinkedInError);
        }
    }

}

class PendingInvitationLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "PendingInvitationLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PendingInvitationLinkedInError);
        }
    }

}

class CannotResendYetLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "CannotResendYetLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CannotResendYetLinkedInError);
        }
    }

}

class ConnectIsUnavailableLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ConnectIsUnavailableLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ConnectIsUnavailableLinkedInError);
        }
    }

}

class AutomationUnexpectedlyStoppedError extends SnailyError {

    #loggingFields;
    
    constructor(message, loggingFields, metadata) {
        super(message, metadata);
        this.name = "AutomationUnexpectedlyStoppedError";
        this.#loggingFields = loggingFields;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AutomationUnexpectedlyStoppedError);
        }
    }

    get loggingFields() {
        return this.#loggingFields;
    }

}

class UserVisibilityLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "UserVisibilityLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UserVisibilityLinkedInError);
        }
    }

}

class UnknownMessagingExtensionPluginError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "UnknownMessagingExtensionPluginError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnknownMessagingExtensionPluginError);
        }
    }

}

class TimedOutError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "TimedOutError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TimedOutError);
        }
    }

}

class DeniedBuyAbuseScoringLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "DeniedBuyAbuseScoringLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DeniedBuyAbuseScoringLinkedInError);
        }
    }
}

class CustomMessageTooLongLinkedInError extends LinkedInError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "CustomMessageTooLongLinkedInError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CustomMessageTooLongLinkedInError);
        }
    }
}

const backendLinkedInApiErrorHandler = (function () {

    async function guard(response, metadata) {
        if (!response.ok) {
            let message = await response.text();
            switch (response.status) {
                case 500:
                    throw new ServerError(message, metadata, true);

                case 521:
                    throw new NullResponseError(message, metadata);

                case 522:
                    throw new IncompleteReferenceDataError(message, metadata);

                case 523:
                    throw new MissingContactActionsError(message, metadata);

                case 524:
                    throw new SendingDuplicateMessage(message, metadata);

                case 525:
                    throw new MessageIsUnavailableLinkedInError(message, metadata);

                case 526:
                    throw new MessageTemporarilyUnavailableLinkedInError(message, metadata);

                case 527:
                    throw new NotSupportedResponseError(message, metadata);

                case 528:
                    throw new ConnectTemporarilyUnavailableLinkedInError(message, metadata);

                case 529:
                    throw new EmailRequiredLinkedInError(message, metadata);

                case 530:
                    throw new PendingInvitationLinkedInError(message, metadata);

                case 531:
                    throw new CannotResendYetLinkedInError(message, metadata);

                case 532:
                    throw new ConnectIsUnavailableLinkedInError(message, metadata);

                case 533:
                    throw new AutomationUnexpectedlyStoppedError(message, metadata);

                case 534:
                    throw new ExceedsLimitLinkedInError(message, "backend", metadata);

                case 535:
                    throw new BadRequestError(message, metadata);

                case 536:
                    throw new LinkedInSignInRequiredError(message, metadata);

                case 537:
                    throw new UserVisibilityLinkedInError(message, metadata);

                case 538:
                    throw new NotAuthorizedError(message, metadata);

                case 539:
                    throw new UnknownMessagingExtensionPluginError(message, metadata);

                case 540:
                    throw new TimedOutError(message, metadata);

                case 541:
                    throw new BadGatewayError(message, metadata);

                case 542:
                    throw new NotAuthenticatedError(message, metadata);

                case 543:
                    throw new NotFoundError(message, metadata);

                case 544:
                    throw new ProxyAuthenticationRequiredError(message, metadata);

                case 545:
                    throw new UnprocessableEntityError(message, metadata);

                case 546:
                    throw new ServerError(message, metadata, true);

                case 547:
                    throw new MethodNotAllowedError(message, metadata, true);

                case 548:
                    throw new DeniedBuyAbuseScoringLinkedInError(message, metadata);

                case 549:
                    throw new CustomMessageTooLongLinkedInError(message, metadata);

                case 550:
                    throw new SalesNavigatorNotAuthorizedError(message, metadata);

                case 551:
                    throw new ProxyUnavailableError(message, metadata);

                default:
                    await repositoryErrorHandler.guard(response, metadata);
            }
        }
    }

    const result = {

        guard: guard

    };
    return result;

})();

let Mutex = function () {

    let queue = [];

    async function lock() {
        let lock = {
            resolve: null,
            promise: null
        };
        lock.promise = new SnailyPromise(function (resolve) {
            lock.resolve = resolve;
        });
        queue.push(lock);

        //if first lock then release it immediately to not block first enter
        if (queue.length === 1) {
            lock.resolve();
        }

        return lock.promise;
    }

    function release() {
        if (queue.length === 0) {
            throw new InvalidOperationError("There is not active lock in the queue");
        }

        queue.shift();
        //resolve next lock to let that piece of code be executed
        if (queue.length > 0) {
            queue[0].resolve();
        }
    }

    return {
        lock: lock,
        release: release
    }
};

var apiProxyModule = (function () {

    let _currentExchangeToken = null;
    let _extensionVersion = null;
    let mutex = Mutex();

    async function createMetadataHeaders(metadata) {
        const result = {};
        if (metadata) {
            for (const key of Object.keys(metadata)) {
                let headerKey = "dz-" + key;
                result[headerKey] = metadata[key];
            }
        }

        result["dz-extensionVersion"] = await getExtensionVersion(metadata);
        result["dz-chromeVersion"] = utils.getChromeVersion();
        return result;
    }

    async function createHeaders(metadata, preferTeamMemberHeaders, ignoreExtensionValidation) {
        let accessToken = await concurrentGetAccessToken(preferTeamMemberHeaders, !ignoreExtensionValidation, metadata);
        if (!accessToken) {
            throw new SnailySignInRequiredError("access token is not set, sign in is required", metadata);
        }

        let headers = await createMetadataHeaders(metadata);
        const result = {
            'Content-Type': 'application/json',
            'authorization': accessToken
        };
        if (headers) {
            for (const [key, value] of Object.entries(headers)) {
                result[key] = value;
            }
        }

        return result;
    }

    function composeApiV1Uri(relativeUri) {
        let result = `${config.backend.api_endpoint}api/v1/${relativeUri}`;
        return result;
    }

    function composeAutomationApiV1Uri(relativeUri) {
        let result = `${config.backend.automation_endpoint}v1/${relativeUri}`;
        return result;
    }

    function composeAutomationApiV2Uri(relativeUri) {
        let result = `${config.backend.automation_endpoint}v2/${relativeUri}`;
        return result;
    }

    /**
     * @typedef IdToken
     * @type {object}
     * @property {string} exp
     * @property {string} nbf
     * @property {string} extension_update_required
     */

    /**
     * @typedef AccessToken
     * @type {object}
     * @property {string} exp
     * @property {string} nbf
     */

    /**
     * @return {IdToken|AccessToken}
     */
    function decodeJwtToken(token) {
        let result = o(token);
        return result;
    }

    async function getExtensionVersion(metadata) {
        if (!_extensionVersion) {
            let command = backendCommandsFactory.system.createGetExtensionSettings(metadata);
            let settings = await backendBroker.publish(command);
            _extensionVersion = settings.version;
        }

        return _extensionVersion;
    }

    const localStorage =
        {
            getSignedInPersonaJwtTokens: async function (metadata) {
                const command = backendCommandsFactory.localStorage.createGetSignedInPersonaJwtTokens(metadata);
                const result = await backendBroker.publish(command);
                return result;
            },

            saveSignedInPersonaJwtToken: async function (tokens, timeRequestSent, metadata) {
                let accessToken = decodeJwtToken(tokens.access_token);
                let tokenLifeTimeDurationSeconds = accessToken.exp - accessToken.nbf;
                tokens.access_token_expires_at = tokenLifeTimeDurationSeconds * 1000 + timeRequestSent;

                let command = backendCommandsFactory.localStorage.createSaveSignedInPersonaJwtTokens(tokens, metadata);
                await backendBroker.publish(command);
            },

            deleteSignedInPersonaJwtTokens: async function (metadata) {
                const impersonatedCommand = backendCommandsFactory.localStorage.createDeleteImpersonatedPersonaJwtTokens(metadata);
                await backendBroker.publish(impersonatedCommand);

                const signedInCommand = backendCommandsFactory.localStorage.createDeleteSignedInPersonaJwtTokens(metadata);
                await backendBroker.publish(signedInCommand);

                const signedOut = backendEventsFactory.createSnailySignedOut(metadata);
                await backendBroker.fireEvent(signedOut);
            },

            getImpersonatedPersonaJwtTokens: async function (metadata) {
                const command = backendCommandsFactory.localStorage.createGetImpersonatedPersonaJwtTokens(metadata);
                const result = await backendBroker.publish(command);
                return result;
            },

            saveImpersonatedPersonaJwtToken: async function (tokens, timeRequestSent, metadata) {
                let accessToken = decodeJwtToken(tokens.access_token);
                let tokenLifeTimeDurationSeconds = accessToken.exp - accessToken.nbf;
                tokens.access_token_expires_at = tokenLifeTimeDurationSeconds * 1000 + timeRequestSent;

                let command = backendCommandsFactory.localStorage.createSaveImpersonatedPersonaJwtTokens(tokens, metadata);
                await backendBroker.publish(command);

                let signedIn = backendEventsFactory.createSnailyProfileChanged(metadata);
                await backendBroker.fireEvent(signedIn);
            },

            deleteImpersonatedPersonaJwtTokens: async function (metadata) {
                const command = backendCommandsFactory.localStorage.createDeleteImpersonatedPersonaJwtTokens(metadata);
                await backendBroker.publish(command);

                const signedOut = backendEventsFactory.createSnailyProfileChanged(metadata);
                await backendBroker.fireEvent(signedOut);
            },
        };

    /**
     * @typedef {object} JwtTokens
     * @property {string} token_type
     * @property {string} access_token
     * @property {string} id_token
     * @property {number} refresh_token
     *
     * @return {JwtTokens}
     */

    async function getSignedInPersonaJwtTokens(metadata) {
        let result = await localStorage.getSignedInPersonaJwtTokens(metadata);
        if (result) {
            const fiveSeconds = 1000 * 5;
            if (result.access_token_expires_at - Date.now() < fiveSeconds) {
                await refreshAuthTokens(metadata);
                //ToDo: it cab ne null if refreshToken is invalid and sign-out happened
                result = await localStorage.getSignedInPersonaJwtTokens(metadata);
            }
        }

        return result;
    }

    async function getImpersonatedPersonaJwtTokens(metadata) {
        let result = await localStorage.getImpersonatedPersonaJwtTokens(metadata);
        if (result) {
            const fiveSeconds = 1000 * 5;
            if (result.access_token_expires_at - Date.now() < fiveSeconds) {

                //todo: an event should happens,
                await localStorage.deleteImpersonatedPersonaJwtTokens(metadata);
                result = null;
            }
        }

        return result;
    }

    async function getActualJwtTokens(preferTeamMemberHeaders, metadata) {
        let result = null;
        if (preferTeamMemberHeaders) {
            result = await getImpersonatedPersonaJwtTokens(metadata);
        }

        if (!result) {
            result = await getSignedInPersonaJwtTokens(metadata);
        }

        return result;
    }

    function isCompatibleWithCurrentExtension(jwtTokens) {
        const idToken = decodeJwtToken(jwtTokens.id_token);
        let result = idToken.extension_update_required === "false";
        return result;
    }

    async function concurrentGetAccessToken(preferTeamMemberHeaders, validateExtensionVersion, metadata) {
        await mutex.lock();
        try {
            try {
                let jwtTokens = await getActualJwtTokens(preferTeamMemberHeaders, metadata);
                if (jwtTokens == null) {
                    return null;
                }

                if (validateExtensionVersion && !(isCompatibleWithCurrentExtension(jwtTokens))) {
                    // noinspection ExceptionCaughtLocallyJS
                    throw new OldExtensionError("There is newer extension version.", metadata);
                }

                const result = `${jwtTokens.token_type} ${jwtTokens.access_token}`;
                return result;

            } catch (e) {
                if (e instanceof NotAuthenticatedError) {
                    return null;
                } else {
                    throw e;
                }
            }

        } finally {
            mutex.release();
        }
    }

    async function revokeToken(metadata) {
        let headers = await createMetadataHeaders(metadata);
        headers.authorization = await concurrentGetAccessToken(false, false, metadata);
        let jwtTokens = await localStorage.getSignedInPersonaJwtTokens(metadata);
        // #1466 (Snaily backlog)
        if (!jwtTokens || !jwtTokens.refresh_token) {
            return;
        }

        let formData = new FormData();
        formData.append("token", jwtTokens.refresh_token);

        let apiUri = composeApiV1Uri('auth/revoke');
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: headers,
                body: formData
            }, metadata);

        return result;
    }

    async function refreshAuthTokens(metadata) {
        let jwtTokens = await localStorage.getSignedInPersonaJwtTokens(metadata);
        let concurrentArgs = {
            parameter: {
                grantType: 'refresh_token',
                refreshToken: jwtTokens.refresh_token
            },
            metadata: metadata
        };
        await concurrentExchangeToken(concurrentArgs);

        const profileChanged = backendEventsFactory.createSnailyProfileChanged(metadata);
        await backendBroker.fireEvent(profileChanged);
    }

    /**
     * @typedef {object} Export
     * @property {boolean} is_visited
     * @property {string} started
     * @property {string} id
     *
     * @return {Array.<Export>}
     */
    async function getRecentExports(args) {
        let apiUri = composeApiV1Uri(`workspace/imports/recent?$take=5`);
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function createExportTag(args) {
        let payload = {
            type: args.parameter.type,
            metadata: args.parameter.metadata,
            name: args.parameter.name
        };
        let apiUri = composeAutomationApiV1Uri('tags');
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata, true),
                body: JSON.stringify(payload)
            }, args.metadata);
        return result;
    }

    async function exportTaggedContacts(args) {
        let apiUri = composeAutomationApiV1Uri(`tags/${args.parameter.tagId}/contacts`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata, true),
                body: JSON.stringify(args.parameter.contacts)
            }, args.metadata);

        return result;
    }

    async function addMetadataToTag(args) {
        let apiUri = composeAutomationApiV1Uri(`tags/${args.parameter.tagId}/metadata`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata, true),
                body: JSON.stringify(args.parameter.metadata)
            }, args.metadata);

        return result;
    }

    async function syncConversations(args) {
        let apiUri = composeAutomationApiV1Uri('synchronize-conversations');
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify({
                    timestamp: args.parameter.timestamp,
                    conversations: args.parameter.conversations
                }, args.metadata)
            });

        return result;
    }

    async function syncConnections(args) {
        let apiUri = composeAutomationApiV1Uri('sync-connections-v2');
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter.connections)
            }, args.metadata);

        return result;
    }

    async function syncContact(args) {
        let apiUri = composeAutomationApiV1Uri(`contacts/${args.parameter.contactId}`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter.contact)
            }, args.metadata);

        return result;
    }

    async function getNextOperations(args) {
        let apiUri = composeAutomationApiV1Uri('next-operations');
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function getOperation(args) {
        let apiUri = composeAutomationApiV1Uri(`operations/${args.parameter.campaignExecutionId}/${args.parameter.stepNumber}`);
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function getWithdrawOperations(args) {
        let apiUri = composeAutomationApiV1Uri('withdraw-operations');
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function stepExecuted(args) {
        let apiUri = composeAutomationApiV1Uri(`campaigns/${args.parameter.campaignId}/executions/${args.parameter.campaignExecutionId}/steps/${args.parameter.stepNumber}/executed`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter.actionResult)
            }, args.metadata);

        return result;
    }

    async function stepExecutionError(args) {
        let apiUri = composeAutomationApiV1Uri(`campaigns/${args.parameter.campaignId}/executions/${args.parameter.campaignExecutionId}/steps/${args.parameter.stepNumber}/error`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function stepSkipped(args) {
        let apiUri = composeAutomationApiV1Uri(`campaigns/${args.parameter.campaignId}/executions/${args.parameter.campaignExecutionId}/steps/${args.parameter.stepNumber}/skipped`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify({reason: args.parameter.reason})
            }, args.metadata);

        return result;
    }

    async function reportExceedLimit(args) {
        let apiUri = composeAutomationApiV1Uri(`exceed-limit/${args.parameter.operationType}`);
        let payload = {
            code: args.parameter.code,
            campaign_id: args.parameter.campaignId
        };
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(payload)
            }, args.metadata);

        return result;
    }

    async function stepWithdrawn(args) {
        let apiUri = composeAutomationApiV1Uri(`campaigns/${args.parameter.campaignId}/executions/${args.parameter.campaignExecutionId}/steps/${args.parameter.stepNumber}/withdrawn`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function stepWithdrawError(args) {
        let apiUri = composeAutomationApiV1Uri(`campaigns/${args.parameter.campaignId}/executions/${args.parameter.campaignExecutionId}/steps/${args.parameter.stepNumber}/withdraw-error`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    /**
     * @typedef {Object} MyProfile
     * @property {number} synced_conversations_at
     * @property {number} synced_connections_at
     * @property {number} created
     * @property {number} min_actions_pause
     * @property {number} max_actions_pause
     * @return {MyProfile}
     */
    async function getMyProfile(args) {
        let apiUri = composeAutomationApiV1Uri('latest-activities');
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function addLinkedInProfile(args) {
        let apiUri = composeApiV1Uri('persona/linkedin-profiles');
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata, false, true),
                body: JSON.stringify(args.parameter.linkedInProfile)
            }, args.metadata);

        return result;
    }

    async function getLinkedInProfiles(args) {
        let apiUri = composeApiV1Uri('persona/linkedin-profiles/page');
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata, false, true)
            }, args.metadata);

        return result;
    }

    /**
     * @typedef {Object} Period
     * @property {number} start
     * @property {number} duration
     *
     * @typedef {Object} Week
     * @property {Period} monday
     * @property {Period} tuesday
     * @property {Period} wednesday
     * @property {Period} thursday
     * @property {Period} friday
     * @property {Period} saturday
     * @property {Period} sunday
     *
     * @return {Week}
     */
    async function getWorkingHours(args) {
        let apiUri = composeApiV1Uri('workspace/working-hours-in-minutes');
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata, args.parameter.preferTeamMemberHeaders)
            }, args.metadata);

        return result;
    }

    async function setWorkingHours(args) {
        let apiUri = composeApiV1Uri('workspace/working-hours');
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                body: JSON.stringify(args.parameter.workingHours),
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function setRunningActivities(args) {
        let apiUri = composeAutomationApiV1Uri('running-activities');
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify({state: args.parameter.state})
            }, args.metadata);

        return result;
    }

    async function extensionDetected(args) {
        let apiUri = composeAutomationApiV1Uri('extension-detected');
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function getCurrentDateTime(args) {
        let apiUri = composeApiV1Uri('system/current-date-time');
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function getTeamMemberTokens(args) {
        let apiUri = composeApiV1Uri(`team/${args.parameter.personaId}/signin`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function refreshCampaignExecutions(args) {
        let apiUri = composeAutomationApiV1Uri('refresh-executions');
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function endAutomationRun(args) {
        let apiUri = composeAutomationApiV1Uri('end-automation-run');
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function exchangeToken(args) {
        let parameter = args.parameter;
        const formData = new FormData();
        formData.append("client_id", config.oauth.client_id);
        formData.append("client_secret", config.oauth.client_secret);
        formData.append("grant_type", parameter.grantType);
        formData.append("access_type", "offline");
        let extensionVersion = await getExtensionVersion(args.metadata);
        formData.append("extensionVersion", extensionVersion);
        switch (parameter.grantType) {
            case 'refresh_token':
                // this might happens for impersonated profile
                if (!parameter.refreshToken) {
                    throw new InvalidOperationError("No refresh token", args.metadata);
                }
                formData.append("refresh_token", parameter.refreshToken);
                break;
            case 'authorization_code':
                formData.append("code", parameter.code);
                break;
            default:
                throw new InvalidOperationError(`Unknown grant type - ${parameter.grantType}.`, args.metadata);
        }

        let timeRequestSent = Date.now();
        let apiUri = composeApiV1Uri('auth/token');
        const response = await httpRequest(apiUri,
            {
                method: 'POST',
                body: formData,
                headers: await createMetadataHeaders(args.metadata)
            }, args.metadata);
        await apiErrorHandler.guard(response, args.metadata);
        // seems obsolete one and has to be deleted after version 0.9.6.4
        if (response.status === 204) {
            throw new NotAuthenticatedError("Snaily API didn't find this exchange token.", args.metadata)
        }
        const snailyJwtTokens = await response.json();
        await localStorage.saveSignedInPersonaJwtToken(snailyJwtTokens, timeRequestSent, args.metadata);
    }

    async function concurrentExchangeToken(args) {
        if (_currentExchangeToken == null) {
            _currentExchangeToken = exchangeToken(args);
        }

        try {
            await _currentExchangeToken;
        } catch (e) {
            // do sign out when exchange token is not authorized 
            if (e instanceof NotAuthenticatedError || e instanceof InvalidOperationError) {
                await localStorage.deleteSignedInPersonaJwtTokens(args.metadata);
            } else {
                throw e;
            }
        } finally {
            _currentExchangeToken = null;
        }
    }

    async function switchToWorkspace(args) {
        let extensionVersion = await getExtensionVersion(args.metadata);
        let apiUri = composeApiV1Uri(`persona/linkedin-profiles/${args.parameter.linkedInProfileId}/switch`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata, false, true),
                body: JSON.stringify({extension_version: extensionVersion})
            }, args.metadata);

        return result;
    }

    async function reportLogEntry(args) {
        let apiUri = composeApiV1Uri(`logs/${args.parameter.severity.toLowerCase()}`);
        let logEntry = {
            severity: args.parameter.severity,
            event_id: args.parameter.logEventId,
            message: args.parameter.message,
            args: args.parameter.args
        };
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata, false, true),
                body: JSON.stringify(logEntry)
            }, args.metadata);

        return result;
    }

    async function reportCustomMessageTooLong(args) {
        let apiUri = composeAutomationApiV1Uri(`campaigns/${args.parameter.campaignId}/executions/${args.parameter.campaignExecutionId}/steps/${args.parameter.stepNumber}/custom-message-too-long`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata)
            }, args.metadata);

        return result;
    }

    async function interpretArrayResponse(response) {
        let result;
        if (response.status !== 204) {
            result = await response.json();
        } else {
            result = [];
        }
        return result;
    }

    async function isNotAuthorized(metadata, response) {
        let result = response.status === 401 || response.status === 403;
        if (result) {
            await refreshAuthTokens(metadata);
        }

        return result;
    }

    function initBrokerSubscriptions() {
        backendBroker.subscribeForCommands(backendTopics.apiProxy, this);
    }

    async function createLinkedInTrackingId(args) {
        let apiUri = composeAutomationApiV1Uri(`tracking-id?uuid=${args.parameter.uuid}`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
            }, args.metadata);
        return result;
    }

    // linkedinService
    async function getLinkedInContactsFromSearchPage(args) {
        let apiUri = composeAutomationApiV2Uri(`linkedin-contacts/get-from-search-page`);
        let parameters = [];
        for (const key in args.parameter.searchRequest.parameters) {
            let parameter = {
                key: key,
                value: args.parameter.searchRequest.parameters[key]
            };
            parameters.push(parameter);
        }
        let payload = {
            searchRequest: {
                start: args.parameter.searchRequest.start,
                pageSize: args.parameter.searchRequest.pageSize,
                parameters: parameters
            },
            referrer: args.parameter.referrer
        };
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(payload)
            }, args.metadata);
        return result;
    }

    async function getLinkedInContactsFromMyConnections(args) {
        let apiUri = composeAutomationApiV2Uri(`linkedin-contacts/get-from-my-connections-page`);
        let payload = {
            start: args.parameter.start,
            count: args.parameter.count
        };
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(payload)
            }, args.metadata);
        return result;
    }

    async function getLinkedInConnectionsCount(args) {
        let apiUri = composeAutomationApiV2Uri(`connections/count`);
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);
        return result;
    }

    async function getLinkedInContactsFromGroupPage(args) {
        let apiUri = composeAutomationApiV2Uri(`linkedin-contacts/get-from-group-page`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter)
            }, args.metadata);
        return result;
    }

    async function getSalesNavigatorContactsFromSearchPage(args) {
        let apiUri = composeAutomationApiV2Uri(`sales-navigator-contacts/get-from-search-page`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter)
            }, args.metadata);
        return result;
    }

    async function getSalesNavigatorContactsFromLeadsList(args) {
        let apiUri = composeAutomationApiV2Uri(`sales-navigator-contacts/get-from-leads-list`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter)
            }, args.metadata);
        return result;
    }

    async function saveLinkedinHeaders(args) {
        let apiUri = composeAutomationApiV2Uri(`cookies-and-headers`);
        const result = await httpRequest(apiUri,
            {
                method: 'PUT',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter)
            }, args.metadata);
        return result;
    }

    async function getCurrentLinkedInProfile(args) {
        let apiUri = composeAutomationApiV2Uri(`me-v2`);
        const result = await httpRequest(apiUri,
            {
                method: 'POST',
                headers: await createHeaders(args.metadata),
                body: JSON.stringify(args.parameter)
            }, args.metadata);
        return result;
    }

    async function getContact(args) {
        let apiUri = composeApiV1Uri(`contacts/${args.parameter.id}`);
        const result = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createHeaders(args.metadata)
            }, args.metadata);
        return result;
    }

    const moduleResult = {

        createExportTag: async function (args) {
            let response = await createExportTag(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await createExportTag(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        exportTaggedContacts: async function (args) {
            let response = await exportTaggedContacts(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await exportTaggedContacts(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        addMetadataToTag: async function (args) {
            let response = await addMetadataToTag(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await addMetadataToTag(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        syncConversations: async function (args) {
            let response = await syncConversations(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await syncConversations(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        syncConnections: async function (args) {
            let response = await syncConnections(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await syncConnections(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        syncContact: async function (args) {
            let response = await syncContact(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await syncContact(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        refreshCampaignExecutions: async function (args) {
            let response = await refreshCampaignExecutions(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await refreshCampaignExecutions(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        endAutomationRun: async function (args) {
            let response = await endAutomationRun(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await endAutomationRun(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        /**
         * @typedef {Object} NextOperation
         * @property {string} campaign_id
         * @property {string} campaign_execution_id
         * @property {string} invitation_id
         * @property {string} operation_type
         * @property {string} linkedin_public_identifier
         * @property {string} linkedin_entity_id
         * @property {string} linkedin_contact_id
         * @property {number} step_number
         * @return {NextOperation}
         */
        getNextOperations: async function (args) {
            let response = await getNextOperations(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getNextOperations(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = response.status === 200
                ? await response.json()
                : null;
            return result;
        },

        getOperation: async function (args) {
            let response = await getOperation(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getOperation(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = response.status === 200
                ? await response.json()
                : null;
            return result;
        },

        getWithdrawOperations: async function (args) {
            let response = await getWithdrawOperations(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getWithdrawOperations(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await interpretArrayResponse(response);
            return result;
        },

        stepExecuted: async function (args) {
            let response = await stepExecuted(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await stepExecuted(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        stepExecutionError: async function (args) {
            let response = await stepExecutionError(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await stepExecutionError(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        stepSkipped: async function (args) {
            let response = await stepSkipped(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await stepSkipped(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        reportExceedLimit: async function (args) {
            let response = await reportExceedLimit(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await reportExceedLimit(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        stepWithdrawn: async function (args) {
            let response = await stepWithdrawn(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await stepWithdrawn(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        stepWithdrawError: async function (args) {
            let response = await stepWithdrawError(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await stepWithdrawError(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        getMyProfile: async function (args) {
            let response = await getMyProfile(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getMyProfile(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        revokeToken: async function (args) {
            try {
                try {
                    let response = await revokeToken(args.metadata);
                    if (await isNotAuthorized(args.metadata, response)) {
                        response = await revokeToken(args.metadata);
                    }

                    await apiErrorHandler.guard(response, args.metadata);
                } catch (error) {
                    if (!(error instanceof BadGatewayError ||
                        error instanceof OldExtensionError ||
                        error instanceof NotAuthenticatedError ||
                        error instanceof NotAuthorizedError)) {
                        throw error;
                    }
                }
            } finally {
                await localStorage.deleteSignedInPersonaJwtTokens(args.metadata);
            }
        },

        exchangeAuthorizationCode: async function (args) {
            let commandArgs = {
                parameter: {
                    grantType: 'authorization_code',
                    code: args.parameter.code,
                    headers: await createMetadataHeaders(args.metadata)
                },
                metadata: args.metadata
            };
            await concurrentExchangeToken(commandArgs);

            let signedIn = backendEventsFactory.createSnailySignedIn(args.metadata);
            await backendBroker.fireEvent(signedIn);
        },

        switchToWorkspace: async function (args) {
            try {
                const timeRequestSent = Date.now();

                let response = await switchToWorkspace(args);
                await apiErrorHandler.guard(response, args.metadata);

                const snailyJwtTokens = await response.json();
                await localStorage.saveSignedInPersonaJwtToken(snailyJwtTokens, timeRequestSent, args.metadata);

                const snailyProfileChanged = backendEventsFactory.createSnailyProfileChanged(args.metadata);
                await backendBroker.fireEvent(snailyProfileChanged);

            } catch (e) {
                // do sign out when exchange token is not authorized 
                if (e instanceof NotAuthenticatedError || e instanceof InvalidOperationError) {
                    await localStorage.deleteSignedInPersonaJwtTokens(args.metadata);
                } else {
                    throw e;
                }
            }
        },

        signInUnderTeamMember: async function (args) {
            let timeRequestSent = Date.now();
            let response = await getTeamMemberTokens(args);
            if (await isNotAuthorized(args.metadata, response)) {
                timeRequestSent = Date.now();
                response = await getTeamMemberTokens(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const tokens = await response.json();
            await localStorage.saveImpersonatedPersonaJwtToken(tokens, timeRequestSent, args.metadata);
            return tokens;
        },

        signOutUnderTeamMember: async function (args) {
            await localStorage.deleteImpersonatedPersonaJwtTokens(args.metadata);
        },

        getRecentExports: async function (args) {
            let response = await getRecentExports(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getRecentExports(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await interpretArrayResponse(response);
            return result;
        },

        addLinkedInProfile: async function (args) {
            let response = await addLinkedInProfile(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await addLinkedInProfile(args);
            }

            try {
                await apiErrorHandler.guard(response, args.metadata);
                const result = await response.json();
                return result;
            } catch (exp) {
                if (exp instanceof UnprocessableEntityError) {
                    const body = JSON.parse(exp.message);
                    const firstError = body.errors[0];
                    if (firstError.code === "LinkedInProfileAlreadyUsed") {
                        throw new LinkedInProfileAlreadyUsedError(firstError.description, args.metadata);
                    }
                }

                throw exp;
            }
        },

        getLinkedInProfiles: async function (args) {
            let response = await getLinkedInProfiles(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getLinkedInProfiles(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await interpretArrayResponse(response);
            return result;
        },

        getWorkingHours: async function (args) {
            let response = await getWorkingHours(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getWorkingHours(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        setWorkingHours: async function (args) {
            let response = await setWorkingHours(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await setWorkingHours(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            const workingHoursChanged = backendEventsFactory.createWorkingHoursChanged(args.metadata);
            await backendBroker.fireEvent(workingHoursChanged);
        },

        setRunningActivities: async function (args) {
            let response = await setRunningActivities(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await setRunningActivities(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        extensionDetected: async function (args) {
            let response = await extensionDetected(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await extensionDetected(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        getCurrentDateTime: async function (args) {
            let response = await getCurrentDateTime(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getCurrentDateTime(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
            let payload = await response.json();
            const result = utils.toDateFromIso8651(payload.now);
            return result;
        },

        reportLogEntry: async function (args) {
            let response = await reportLogEntry(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await reportLogEntry(args);
            }

            await apiErrorHandler.guard(response, args.metadata);
        },

        refreshAuthTokens: async function (args) {
            await refreshAuthTokens(args.metadata);
        },

        getAccessToken: async function (args) {
            let result = await concurrentGetAccessToken(true, false, args.metadata);
            return result;
        },

        isCompatibleWithCurrentExtension: async function (args) {
            let jwtTokens = await getSignedInPersonaJwtTokens(args.metadata);
            let result = isCompatibleWithCurrentExtension(jwtTokens);
            return result;
        },

        createLinkedInTrackingId: async function (args) {
            let response = await createLinkedInTrackingId(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await createLinkedInTrackingId(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = utils.cutEdges(await response.text());
            return result;
        },

        reportCustomMessageTooLong: async function (args) {
            let response = await reportCustomMessageTooLong(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await reportCustomMessageTooLong(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
        },

        getLinkedInContactsFromSearchPage: async function (args) {
            let response = await getLinkedInContactsFromSearchPage(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getLinkedInContactsFromSearchPage(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        getLinkedInContactsFromMyConnections: async function (args) {
            let response = await getLinkedInContactsFromMyConnections(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getLinkedInContactsFromMyConnections(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            let result = await response.json();
            return result;
        },

        getLinkedInConnectionsCount: async function (args) {
            let response = await getLinkedInConnectionsCount(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getLinkedInConnectionsCount(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        getLinkedInContactsFromGroupPage: async function (args) {
            let response = await getLinkedInContactsFromGroupPage(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getLinkedInContactsFromGroupPage(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        getSalesNavigatorContactsFromSearchPage: async function (args) {
            let response = await getSalesNavigatorContactsFromSearchPage(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getSalesNavigatorContactsFromSearchPage(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        getSalesNavigatorContactsFromLeadsList: async function (args) {
            let response = await getSalesNavigatorContactsFromLeadsList(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getSalesNavigatorContactsFromLeadsList(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        saveLinkedinHeaders: async function (args) {
            let response = await saveLinkedinHeaders(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await saveLinkedinHeaders(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
        },

        getContact: async function (args) {
            let response = await getContact(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getContact(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
        },

        getCurrentLinkedInProfile: async function(args){
            let response = await getCurrentLinkedInProfile(args);
            if (await isNotAuthorized(args.metadata, response)) {
                response = await getCurrentLinkedInProfile(args);
            }

            await backendLinkedInApiErrorHandler.guard(response, args.metadata);
            const result = await response.json();
            return result;
            
        },

        initBrokerSubscriptions: initBrokerSubscriptions

    };
    return moduleResult;

})
();

const logEntrySeverity = {
    trace: 'Trace',
    information: 'Information',
    warning: 'Warning',
    error: 'Error',
    getWeight: function (severity) {
        switch (severity) {
            case 'Trace':
                return 0;
            case 'Information':
                return 1;
            case 'Warning':
                return 2;
            case 'Error':
                return 3;
            default:
                throw new InvalidOperationError(`Not supported severity - ${severity}`);
        }
    }
};

const loggingModule = (function () {

    function toString(args) {
        const result = JSON.stringify(args);
        return result;
    }

    async function getUserLoggingSeverity(metadata) {
        let command = backendCommandsFactory.localStorage.createGetUserLogLevel(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function logToServer(severity, args) {
        try {
            let userLoggingSeverity = await getUserLoggingSeverity(args.metadata);
            if (userLoggingSeverity) {
                let userSeverityWeight = logEntrySeverity.getWeight(userLoggingSeverity);
                let entrySeverityWeight = logEntrySeverity.getWeight(severity);
                if (entrySeverityWeight >= userSeverityWeight) {
                    let structuredMessage = '';
                    let parameters = [];
                    for (const key of Object.keys(args.parameter.parameters)) {
                        structuredMessage += " {@" + key + "}";
                        const value = args.parameter.parameters[key];
                        parameters.push(value);
                    }
                    const command = backendCommandsFactory.apiProxy.createReportLogEntry(
                        args.parameter.logEntryId,
                        severity,
                        structuredMessage,
                        parameters,
                        args.metadata);
                    await backendBroker.publish(command);
                }
            }

        } catch (exception) {
            if (exception.skipLogging)
                return;

            consoleLogger.error(JSON.stringify(args));
            consoleLogger.error(exception);
        }
    }

    async function logTrace(args) {
        let str = toString(args);
        consoleLogger.trace(str);
        await logToServer(logEntrySeverity.trace, args);
    }

    async function logInformation(args) {
        let str = toString(args);
        consoleLogger.info(str);
        await logToServer(logEntrySeverity.information, args);
    }

    async function logWarning(args) {
        let str = toString(args);
        consoleLogger.warn(str);
        await logToServer(logEntrySeverity.warning, args);
    }

    async function logError(args) {
        let str = toString(args);
        consoleLogger.error(str);
        await logToServer(logEntrySeverity.error, args);
    }

    let moduleResult = {
        logError: logError,
        logInformation: logInformation,
        logWarning: logWarning,
        logTrace: logTrace,
        initBrokerSubscriptions: initBrokerSubscriptions
    };

    function initBrokerSubscriptions() {
        backendBroker.subscribeForCommands(backendTopics.logging, this);
    }

    return moduleResult;

})();

const systemModuleStub = (function () {

    function getExtensionSettings() {
        let result = {
            version: "5.0.0.0",
            name: "Snaily",
            id: "stub"
        };
        return result;
    }

    function initBrokerSubscriptions() {
        backendBroker.subscribeForCommands(backendTopics.system, this);
    }

    return {
        getExtensionSettings: getExtensionSettings,
        initBrokerSubscriptions: initBrokerSubscriptions
    }

})();

const linkedInOperationTypeConst = {
    connect: 'Connect'
};

const skipOperationReasons = {
    emailRequired: 'EmailRequired',
    pendingInvitation: 'PendingInvitation',
    connectIsUnavailable: 'ConnectIsUnavailable',
    cannotResendInvitationYet: 'CannotResendInvitationYet',
    messageIsUnavailable: 'MessageIsUnavailable',
    sendingDuplicateMessage: 'SendingDuplicateMessage',
    contactNotExist: `ContactNotExist`,
    contactNotVisible: `ContactNotVisible`,
    missedCompanyNameInLastJob: 'MissedCompanyNameInLastJob',
    missedPositionTitleInLastJob: 'MissedPositionTitleInLastJob',
    missedContactFirstName: 'MissedContactFirstName',
    missedContactLastName: 'MissedContactLastName',
    missedContactCountry: 'MissedContactCountry',
    missedCustomField1: 'MissedCustomField1',
    missedCustomField2: 'MissedCustomField2',
    missedCustomField3: 'MissedCustomField3',
    tooLongInvitationMessage: 'TooLongInvitationMessage',
    tooLongMessage: 'TooLongMessage',
    followIsUnavailable: 'FollowIsUnavailable',
    endorseIsUnavailable: 'EndorseIsUnavailable'
};

const LogEntryFields = {
    campaignId: "CampaignId",
    campaignExecutionId: "CampaignExecutionId",
    stepNumber: "StepNumber"
};

var delay = (function () {

    function waitAsync(seconds) {
        const result = new SnailyPromise(function (resolve) {
            console.log(`delay is starting for ${seconds} seconds`);
            setTimeout(function () {
                resolve();
            }, seconds * 1000);
        });
        return result;
    }

    async function randomWaitAsync(minSeconds, maxSeconds) {
        let waitSeconds = Math.floor(Math.random() * (maxSeconds - minSeconds)) + minSeconds;
        await waitAsync(waitSeconds);
    }

    return {
        waitAsync: waitAsync,
        randomWaitAsync: randomWaitAsync
    }
})();

const schedulerSettings = {
    automationPeriodInMinutes: 5,
    syncerPeriodInMinutes: 30
};

((function () {

    let campaignsAlarmName = 'campaignExecutions';
    let syncerAlarmName = 'syncer';
    let _automationSchedule;
    const _runtime = runtimeAdapterFactory();

    async function createCampaignsAutomationAlarm(snailyProfile, metadata) {
        let existingAlarm = await _runtime.getAlarm(campaignsAlarmName);
        if (!existingAlarm) {
            await _runtime.createAlarm(campaignsAlarmName, 1, schedulerSettings.automationPeriodInMinutes);
            const event = backendEventsFactory.createAutomationScheduleCreated(metadata);
            await backendBroker.fireEvent(event);
        }
    }

    async function createSyncerAlarmIfNotAny() {
        let existingAlarm = await _runtime.getAlarm(syncerAlarmName);
        if (!existingAlarm) {
            await _runtime.createAlarm(syncerAlarmName, 1, schedulerSettings.syncerPeriodInMinutes);
        }
    }

    async function deleteCampaignsAutomationAlarm(metadata) {
        // clear home-made scheduler
        _automationSchedule?.cancel();
        _automationSchedule = null;

        // clear alarm
        await _runtime.clearAlarm(campaignsAlarmName);

        const event = backendEventsFactory.createAutomationScheduleDeleted(metadata);
        await backendBroker.fireEvent(event);
    }

    async function getSnailyProfile(metadata) {
        let command = backendCommandsFactory.localStorage.createGetSnailyProfile(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function fireAlarmTriggered(name, metadata) {
        const alarmTriggered = backendEventsFactory.createAutomationScheduleTriggered(name, metadata);
        await backendBroker.fireEvent(alarmTriggered);
    }

    function onAlarm(alarm) {
        const metadata = metadataFactory.create();
        if (alarm.name === campaignsAlarmName) {
            // noinspection JSIgnoredPromiseFromCall
            fireAlarmTriggered(alarm.name, metadata);
        } else if (alarm.name === syncerAlarmName) {
            // noinspection JSIgnoredPromiseFromCall
            syncCampaignsAlarmWithSnailyProfile(metadata);
        }
    }

    async function syncCampaignsAlarmWithSnailyProfile(args) {
        let snailyProfile = await getSnailyProfile(args.metadata);
        let alarm = await _runtime.getAlarm(campaignsAlarmName);
        if (snailyProfile && snailyProfile.subscriptionIsActive && !snailyProfile.isBackendAutomation && snailyProfile.runningActivitiesEnabled && snailyProfile.runningActivitiesSet) {
            if (!alarm) {
                await createCampaignsAutomationAlarm(snailyProfile, args.metadata);
            }
        } else if (alarm) {
            await deleteCampaignsAutomationAlarm(args.metadata);
        }
    }

    async function syncAlarms() {
        let metadata = metadataFactory.create();
        await createSyncerAlarmIfNotAny();
        await syncCampaignsAlarmWithSnailyProfile({metadata: metadata});
    }

    async function setupAlarms() {
        // delete alarms
        await _runtime.clearAlarm(syncerAlarmName);
        await _runtime.clearAlarm(campaignsAlarmName);

        // sync alarms
        await syncAlarms();
    }

    function initBrokerSubscriptions() {
        backendBroker.subscribeForCommands(backendTopics.scheduler, this);
        backendBroker.subscribeToEvent(eventNames.snailySignedIn, syncCampaignsAlarmWithSnailyProfile);
        backendBroker.subscribeToEvent(eventNames.snailySignedOut, syncCampaignsAlarmWithSnailyProfile);
        backendBroker.subscribeToEvent(eventNames.snailyProfileChanged, syncCampaignsAlarmWithSnailyProfile);
        backendBroker.subscribeToEvent(eventNames.linkedInSignedOut, syncCampaignsAlarmWithSnailyProfile);
        backendBroker.subscribeToEvent(eventNames.linkedInProfileDetected, syncCampaignsAlarmWithSnailyProfile);
    }

    function initChromeSubscriptions() {
        _runtime.addAlarmListener(onAlarm);
    }

    let moduleResult = {
        initBrokerSubscriptions: initBrokerSubscriptions,
        initChromeSubscriptions: initChromeSubscriptions,
        startSchedulerAsync: setupAlarms
    };

    return moduleResult;

}))
();

const messageParameters = {
    firstName: '{first name}',
    lastName: '{last name}',
    companyName: '{company name}',
    positionTitle: '{position title}',
    country: '{country}',
    customField1: '{custom field 1}',
    customField2: '{custom field 2}',
    customField3: '{custom field 3}'
};

const operationType = {
    message: 'Message',
    connect: 'Connect',
    follow: 'Follow',
    reactOnPost: 'ReactOnPost',
    endorseSkill: 'EndorseSkill'
};

const campaignsModule = (function () {

    let cancelRunningExecutions = false;
    let startTime;
    let executeCycle = false;

    // extension specific

    async function refreshAuthTokens(metadata) {
        let command = backendCommandsFactory.apiProxy.createRefreshAuthTokens(metadata);
        await backendBroker.publish(command);
    }

    async function getWorkingHours(preferTeamMemberHeaders, metadata) {
        let command = backendCommandsFactory.apiProxy.createGetWorkingHours(preferTeamMemberHeaders, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function getWorkingDay(preferTeamMemberHeaders, weekDay, metadata) {
        let workingHours = await getWorkingHours(preferTeamMemberHeaders, metadata);
        switch (weekDay) {
            case 1:
                return workingHours.monday;
            case 2:
                return workingHours.tuesday;
            case 3:
                return workingHours.wednesday;
            case 4:
                return workingHours.thursday;
            case 5:
                return workingHours.friday;
            case 6:
                return workingHours.saturday;
            default:
                return workingHours.sunday;
        }
    }

    async function reliablePublish(command, metadata) {
        let reliableCommand = backendCommandsFactory.reliability.createReliablePublish(command, metadata);
        await backendBroker.publish(reliableCommand);
    }

    async function resendPendingCommandsIfAny(metadata) {
        let command = backendCommandsFactory.reliability.createResendPendingCommandsIfAny(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function fireAutomationEnded(metadata) {
        const automationEnded = backendEventsFactory.createAutomationEnded(metadata);
        await backendBroker.fireEvent(automationEnded);
    }

    // common

    async function getCurrentDateTime(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetCurrentDateTime(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function readNewConnections(connectedAfter, metadata) {
        let command = backendCommandsFactory.linkedInService.createReadNewConnections(
            connectedAfter,
            metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function syncConnections(profile, metadata) {
        let connectedAfter = profile.synced_connections_at
            ? new Date(profile.synced_connections_at)
            : new Date(profile.created);
        if (await isExecuteOperationsCancellable()) {
            return;
        }

        let connections;
        try {
            connections = await readNewConnections(connectedAfter, metadata);
        } catch (e) {
            if (e instanceof ServerError || e instanceof DeniedBuyAbuseScoringLinkedInError || e instanceof NullResponseError) {
                throw createAutomationStoppedError(e.message, metadata, null);
            }

            throw e;
        }

        if (connections.length > 0) {
            let syncConnectionsCommand = backendCommandsFactory.apiProxy.createSyncConnections(connections, metadata);
            await backendBroker.publish(syncConnectionsCommand);
        }
    }

    async function readNewConversations(createdAfter, createdBefore, metadata) {
        let command = backendCommandsFactory.linkedInService.createReadNewConversations(createdAfter, createdBefore, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function syncConversations(profile, metadata) {
        let createdAfter = profile.synced_conversations_at
            ? new Date(profile.synced_conversations_at)
            : new Date(profile.created);
        let currentDate = await getCurrentDateTime(metadata);
        let createdBefore;
        do {
            if (await isExecuteOperationsCancellable()) {
                return;
            }

            const period = 2;
            createdBefore = utils.addDays(createdAfter, period);
            if (createdBefore > currentDate) {
                createdBefore = currentDate;
            }
            let conversations;
            try {
                conversations = await readNewConversations(createdAfter, createdBefore, metadata);
            } catch (e) {
                if (e instanceof ServerError || e instanceof DeniedBuyAbuseScoringLinkedInError || e instanceof NullResponseError || IncompleteReferenceDataError) {
                    throw createAutomationStoppedError(e.message, metadata, null);
                }

                throw e;
            }

            let syncConnectionsCommand = backendCommandsFactory.apiProxy.createSyncConversations(conversations, createdBefore, metadata);
            await backendBroker.publish(syncConnectionsCommand);

            createdAfter = createdBefore;

            await delay.randomWaitAsync(3, 8);
        } while (createdBefore < currentDate);
    }

    async function refreshExecutions(metadata) {
        let command = backendCommandsFactory.apiProxy.createRefreshCampaignExecutions(metadata);
        await backendBroker.publish(command);
    }

    async function endAutomationRun(metadata) {
        let command = backendCommandsFactory.apiProxy.createEndAutomationRun(metadata);
        await backendBroker.publish(command);
    }

    async function getNextOperations(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetNextOperations(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function getOperation(campaignExecutionId, stepNumber, metadata) {
        let command = backendCommandsFactory.apiProxy.createGetOperation(campaignExecutionId, stepNumber, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function getWithdrawOperations(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetWithdrawOperations(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function getMyProfile(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetMyProfile(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function stepSkipped(operation, reason, metadata) {
        let command = backendCommandsFactory.apiProxy.createStepSkipped(
            operation.campaign_id,
            operation.campaign_execution_id,
            operation.step_number,
            reason,
            metadata);
        await reliablePublish(command, metadata);
    }

    async function reportExceedsLimit(operationType, code, campaignId, metadata) {
        let command = backendCommandsFactory.apiProxy.createReportExceedLimit(operationType, code, campaignId, metadata);
        await reliablePublish(command, metadata);
    }

    async function reportCustomMessageTooLong(operation, metadata) {
        let command = backendCommandsFactory.apiProxy.createReportCustomMessageTooLong(
            operation.campaign_id,
            operation.campaign_execution_id,
            operation.step_number,
            metadata);
        await reliablePublish(command, metadata);
    }

    async function stepExecuted(operation, actionResult, metadata) {
        let command = backendCommandsFactory.apiProxy.createStepExecuted(
            operation.campaign_id,
            operation.campaign_execution_id,
            operation.step_number,
            actionResult,
            metadata);
        await reliablePublish(command, metadata);
    }

    async function stepWithdrawn(operation, metadata) {
        let command = backendCommandsFactory.apiProxy.createStepWithdrawn(
            operation.campaign_id,
            operation.campaign_execution_id,
            operation.step_number,
            metadata);
        await reliablePublish(command, metadata);
    }

    async function stepWithdrawFailed(operation, metadata) {
        let command = backendCommandsFactory.apiProxy.createStepWithdrawError(
            operation.campaign_id,
            operation.campaign_execution_id,
            operation.step_number,
            metadata);
        await reliablePublish(command, metadata);
    }

    async function sendMessage(publicIdentifier, entityId, text, metadata) {
        let command = backendCommandsFactory.linkedInService.createSendMessage(
            publicIdentifier,
            entityId,
            text,
            [],
            metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function connect(publicIdentifier, entityId, message, metadata) {
        let command = backendCommandsFactory.linkedInService.createConnect(
            publicIdentifier,
            entityId,
            message,
            metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function follow(publicIdentifier, entityId, metadata) {
        let command = backendCommandsFactory.linkedInService.createFollow(publicIdentifier, entityId, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function reactOnRecentContactPost(publicIdentifier, entityId, reaction, metadata) {
        let command = backendCommandsFactory.linkedInService.createReactOnRecentContactPost(publicIdentifier, entityId, reaction, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function withdraw(invitationId, metadata) {
        let command = backendCommandsFactory.linkedInService.createWithdraw(invitationId, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function endorseMostPopularContactSkill(publicIdentifier, entityId, metadata) {
        let command = backendCommandsFactory.linkedInService.createEndorseMostPopularContactSkill(publicIdentifier, entityId, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function getSnailyProfile(metadata) {
        let command = backendCommandsFactory.localStorage.createGetSnailyProfile(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function isAutomationAllowed(metadata) {
        let snailyProfile = await getSnailyProfile(metadata);
        if (!snailyProfile.runningActivitiesEnabled) {
            return false;
        }

        let result = await isInWorkingHours(snailyProfile, false, metadata);
        return result;
    }

    async function isInWorkingHours(snailyProfile, preferTeamMemberHeaders, metadata) {
        let currentDateTime = await getCurrentDateTime(metadata);
        let correlationOffset = snailyProfile.timezoneOffset - (currentDateTime.getTimezoneOffset() * -1);
        let dateTime = new Date(currentDateTime.getTime() + correlationOffset * 60 * 1000);
        let weekDay = dateTime.getDay();
        let workingDay = await getWorkingDay(preferTeamMemberHeaders, weekDay, metadata);

        let result = false;
        let fullMinutes = dateTime.getHours() * 60 + dateTime.getMinutes();
        if (workingDay && workingDay[0]) {
            let workingHours = workingDay[0];
            result = workingHours.start <= fullMinutes && workingHours.start + workingHours.duration > fullMinutes;
        }

        return result;
    }

    async function withdrawOperation(operation, metadata) {
        try {
            await withdraw(operation.invitation_id, metadata);
        } catch (e) {
            if (e instanceof UnknownMessagingExtensionPluginError) {
                throw e;
            }

            await stepWithdrawFailed(operation, metadata);
            return;
        }
        await stepWithdrawn(operation, metadata);
    }

    async function getContactFullProfileFromLinkedIn(entityId, publicIdentifier, metadata) {
        let result;
        try {
            if (publicIdentifier) {
                let getByPublicIdentifierCommand = backendCommandsFactory.linkedInService.createGetContactFullProfile(publicIdentifier, metadata);
                result = await backendBroker.publish(getByPublicIdentifierCommand);
            } else {
                throw new InvalidOperationError(`Public identifier is not defined`, metadata);
            }

        } catch (publicIdentifierError) {
            if (publicIdentifierError instanceof UserVisibilityLinkedInError) {
                throw publicIdentifierError;
            }

            if (entityId) {
                let getByEntityIdCommand = backendCommandsFactory.linkedInService.createGetContactFullProfile(entityId, metadata);
                result = await backendBroker.publish(getByEntityIdCommand);
            } else {
                throw publicIdentifierError;
            }
        }

        return result;
    }

    async function getSnailyContact(id, metadata) {
        let command = backendCommandsFactory.apiProxy.backendAutomation.createGetContact(id, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    async function syncContact(contactId, contact, metadata) {
        // tracing last job, how frequently it happens
        let lastJob = contact.lastJob ?? {companyName: null, title: null};
        if (!lastJob.companyName || !lastJob.title) {
            let parameters = {
                companyName: lastJob.companyName,
                positionTitle: lastJob.title,
                publicIdentifier: contact.miniProfile.publicIdentifier,
                entityId: contact.miniProfile.entityId
            };
            await logInformation(logEntryIds.incompleteJobTracing, parameters, metadata);
        }

        let command = backendCommandsFactory.apiProxy.createSyncContact(contactId, contact, metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    function createAutomationStoppedError(errorMessage, metadata, operation) {
        let loggingFields = {};
        if (operation) {
            loggingFields[LogEntryFields.campaignId] = operation.campaign_id;
            loggingFields[LogEntryFields.campaignExecutionId] = operation.campaign_execution_id;
            loggingFields[LogEntryFields.stepNumber] = operation.step_number;
        }

        let result = new AutomationUnexpectedlyStoppedError(errorMessage, loggingFields, metadata);
        return result;
    }

    async function executeOperation(operation, metadata) {
        //if (operation.step_number === 0) 
        {
            let miniContact;
            try {
                miniContact = await getContactFullProfileFromLinkedIn(operation.linkedin_entity_id, operation.linkedin_public_identifier, metadata);
            } catch (contactError) {
                if (contactError instanceof UserVisibilityLinkedInError) {
                    await stepSkipped(operation, skipOperationReasons.contactNotVisible, metadata);
                } else if (contactError instanceof NotFoundError) {
                    await stepSkipped(operation, skipOperationReasons.contactNotExist, metadata);
                } else if (contactError instanceof ServerError
                    || contactError instanceof BadRequestError
                    || contactError instanceof ProxyAuthenticationRequiredError
                    || contactError instanceof TimedOutError
                    || contactError instanceof NullResponseError) {
                    throw createAutomationStoppedError(contactError.message, metadata, operation);
                } else {
                    await reportException(contactError, metadata);
                    throw createAutomationStoppedError("Unexpected error when getting mini contact", metadata, operation);
                    //await stepFailed(contactError, operation, metadata);
                }
                return;
            }

            await syncContact(operation.linkedin_contact_id, miniContact, metadata);
        }

        let actualOperation;
        try {
            actualOperation = await getOperation(operation.campaign_execution_id, operation.step_number, metadata);
        } catch (actualOperationError) {
            if (actualOperationError instanceof NotAuthenticatedError || actualOperationError instanceof NotAuthorizedError) {
                throw actualOperationError;
            }

            // for a reason we marked execution as failed when Error occurs during reading, 99% it is a bug 
            // entire try,catch is not needed at all 

            //await stepFailed(actualOperationError, operation, metadata);
            throw actualOperationError;
        }

        if (actualOperation.message?.includes(messageParameters.firstName)) {
            await stepSkipped(operation, skipOperationReasons.missedContactFirstName, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.lastName)) {
            await stepSkipped(operation, skipOperationReasons.missedContactLastName, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.companyName)) {
            await stepSkipped(operation, skipOperationReasons.missedCompanyNameInLastJob, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.positionTitle)) {
            await stepSkipped(operation, skipOperationReasons.missedPositionTitleInLastJob, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.country)) {
            await stepSkipped(operation, skipOperationReasons.missedContactCountry, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.customField1)) {
            await stepSkipped(operation, skipOperationReasons.missedCustomField1, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.customField2)) {
            await stepSkipped(operation, skipOperationReasons.missedCustomField2, metadata);
            return;
        }

        if (actualOperation.message?.includes(messageParameters.customField3)) {
            await stepSkipped(operation, skipOperationReasons.missedCustomField3, metadata);
            return;
        }

        let actionResult = null;
        switch (actualOperation.operation_type) {
            case operationType.message:
                if (actualOperation.message.length > 3000) {
                    await stepSkipped(operation, skipOperationReasons.tooLongMessage, metadata);
                    return;
                }

                try {
                    actionResult = await sendMessage(
                        actualOperation.linkedin_public_identifier,
                        actualOperation.linkedin_entity_id,
                        actualOperation.message,
                        metadata);
                } catch (messageError) {
                    if (messageError instanceof MessageIsUnavailableLinkedInError) {
                        await stepSkipped(operation, skipOperationReasons.messageIsUnavailable, metadata);
                    } else if (messageError instanceof SendingDuplicateMessage) {
                        await stepSkipped(operation, skipOperationReasons.sendingDuplicateMessage, metadata);
                    } else if (messageError instanceof NotSupportedResponseError
                        || messageError instanceof MessageTemporarilyUnavailableLinkedInError
                        || messageError instanceof ServerError
                        || messageError instanceof ProxyAuthenticationRequiredError
                        || messageError instanceof NullResponseError
                        || messageError instanceof BadRequestError
                        || messageError instanceof TimedOutError
                        || messageError instanceof MissingContactActionsError
                        || messageError instanceof IncompleteReferenceDataError) {
                        throw createAutomationStoppedError(messageError.message, metadata, operation);
                    } else {
                        throw messageError;
                        //await stepFailed(messageError, operation, metadata);
                    }

                    return;
                }
                await stepExecuted(operation, actionResult, metadata);
                break;

            case operationType.connect:
                if (actualOperation.message?.length > 300) {
                    await stepSkipped(operation, skipOperationReasons.tooLongInvitationMessage, metadata);
                    return;
                }
                try {
                    actionResult = await connect(
                        actualOperation.linkedin_public_identifier,
                        actualOperation.linkedin_entity_id,
                        actualOperation.message,
                        metadata);
                } catch (connectError) {
                    if (connectError instanceof EmailRequiredLinkedInError) {
                        await stepSkipped(operation, skipOperationReasons.emailRequired, metadata);
                    } else if (connectError instanceof PendingInvitationLinkedInError) {
                        await stepSkipped(operation, skipOperationReasons.pendingInvitation, metadata);
                    } else if (connectError instanceof ConnectIsUnavailableLinkedInError) {
                        await stepSkipped(operation, skipOperationReasons.connectIsUnavailable, metadata);
                    } else if (connectError instanceof CannotResendYetLinkedInError) {
                        await stepSkipped(operation, skipOperationReasons.cannotResendInvitationYet, metadata);
                    } else if (connectError instanceof ExceedsLimitLinkedInError) {
                        await reportExceedsLimit(linkedInOperationTypeConst.connect, connectError.Code, operation.campaign_id, metadata);
                    } else if (connectError instanceof CustomMessageTooLongLinkedInError) {
                        await reportCustomMessageTooLong(operation, metadata);
                    } else if (connectError instanceof NotSupportedResponseError
                        || connectError instanceof ConnectTemporarilyUnavailableLinkedInError
                        || connectError instanceof ServerError
                        || connectError instanceof ProxyAuthenticationRequiredError
                        || connectError instanceof BadRequestError
                        || connectError instanceof TimedOutError
                        || connectError instanceof MissingContactActionsError
                        || connectError instanceof IncompleteReferenceDataError) {
                        throw createAutomationStoppedError(connectError.message, metadata, operation);
                    } else if (connectError instanceof ConnectTemporarilyUnavailableLinkedInError) {
                        throw createAutomationStoppedError("500 error during sending invitation", metadata, operation);
                    } else {
                        throw connectError;
                        //await stepFailed(connectError, operation, metadata);
                    }
                    return;
                }
                await stepExecuted(operation, actionResult, metadata);
                break;

            case operationType.follow:
                try {
                    actionResult = await follow(
                        actualOperation.linkedin_public_identifier,
                        actualOperation.linkedin_entity_id,
                        metadata);
                } catch (followError) {
                    if (followError instanceof MethodNotAllowedError) {
                        await stepSkipped(operation, skipOperationReasons.followIsUnavailable, metadata);
                    } else {
                        throw followError;
                    }

                    return;
                }
                await stepExecuted(operation, actionResult, metadata);
                break;

            case operationType.reactOnPost:
                actionResult = await reactOnRecentContactPost(
                    actualOperation.linkedin_public_identifier,
                    actualOperation.linkedin_entity_id,
                    actualOperation.reaction,
                    metadata);
                await stepExecuted(operation, actionResult, metadata);
                break;

            case operationType.endorseSkill:
                let contact = await getSnailyContact(actualOperation.linkedin_contact_id, metadata);
                if (contact.distance !== 1) {
                    await stepSkipped(operation, skipOperationReasons.endorseIsUnavailable, metadata);
                    return;
                }

                actionResult = await endorseMostPopularContactSkill(
                    actualOperation.linkedin_public_identifier,
                    actualOperation.linkedin_entity_id,
                    metadata);
                await stepExecuted(operation, actionResult, metadata);
                break;

            default:
                throw new InvalidOperationError(`Unknown operation type - ${operation.operation_type}.`, metadata);
        }
    }

    async function reportError(parameters, metadata) {
        let command = backendCommandsFactory.logging.createLogError(logEntryIds.runExecutionsError, parameters, metadata);
        await backendBroker.publish(command);
    }

    async function reportException(error, metadata) {
        if (error instanceof LinkedInSignInRequiredError || error.skipLogging) {
            return;
        }

        if (error instanceof UnknownMessagingExtensionPluginError) {
            await reportExtensionDetected(metadata);
            return;
        }

        if (error instanceof AutomationUnexpectedlyStoppedError) {
            let parameters = errorParametersFactory.create(error);
            parameters = {...parameters, ...error.loggingFields};
            await logWarning(logEntryIds.automationUnexpectedlyStopped, parameters, metadata);
            return;
        }

        const parameters = errorParametersFactory.create(error);
        await reportError(parameters, metadata);
    }

    async function logInformation(logEntryId, parameters, metadata) {
        let command = backendCommandsFactory.logging.createLogInformation(logEntryId, parameters, metadata);
        await backendBroker.publish(command);
    }

    async function logWarning(logEntryId, parameters, metadata) {
        let command = backendCommandsFactory.logging.createLogWaring(logEntryId, parameters, metadata);
        await backendBroker.publish(command);
    }

    async function reportExtensionDetected(metadata) {
        let command = backendCommandsFactory.apiProxy.createExtensionDetected(metadata);
        await backendBroker.publish(command);
    }

    async function isExecuteOperationsCancellable() {
        if (cancelRunningExecutions) {
            return true;
        }

        let remainingSeconds = getRemainingSecondsInCycle();
        let result = remainingSeconds < 30;
        return result;
    }

    function getRemainingSecondsInCycle() {
        let currentTime = new Date();
        let executionInSeconds = (currentTime - startTime) / 1000;
        let result = schedulerSettings.automationPeriodInMinutes * 60 - executionInSeconds;
        return result;
    }

    async function onAutomationScheduleTriggered(args) {
        if (executeCycle) {
            return;
        }

        cancelRunningExecutions = false;
        startTime = new Date();
        let metadata = args.metadata;
        try {
            executeCycle = true;
            await resendPendingCommandsIfAny(metadata);
            await refreshAuthTokens(metadata);

            let canContinue = await isAutomationAllowed(metadata);
            if (!canContinue) {
                return;
            }

            const profile = await getMyProfile(metadata);
            await delay.randomWaitAsync(profile.min_actions_pause * 60, profile.max_actions_pause * 60);

            await syncConnections(profile, metadata);

            // to avoid ExceedsLimitLinkedInError
            await delay.randomWaitAsync(8, 15);
            await syncConversations(profile, metadata);

            if (await isExecuteOperationsCancellable()) {
                return;
            }

            await refreshExecutions(metadata);

            if (await isExecuteOperationsCancellable()) {
                return;
            }

            let withdrawOperations = await getWithdrawOperations(metadata);
            for (let operation of withdrawOperations) {
                await delay.randomWaitAsync(1, 4);
                if (await isExecuteOperationsCancellable()) {
                    return;
                }
                await withdrawOperation(operation, metadata);
            }

            const tooManyWithdraw = 24;
            if (withdrawOperations && withdrawOperations.length >= tooManyWithdraw) {
                return;
            }

            if (await isExecuteOperationsCancellable()) {
                return;
            }

            let nextOperations = await getNextOperations(metadata);
            let delayAfterPreviousAction = 0;
            if (nextOperations) {
                await delay.randomWaitAsync(0, 20);
                for (let nextOperation of nextOperations) {
                    await delay.waitAsync(delayAfterPreviousAction);
                    await delay.randomWaitAsync(0, 10);
                    if (await isExecuteOperationsCancellable()) {
                        return;
                    }
                    await refreshExecutions(metadata);

                    if (await isExecuteOperationsCancellable()) {
                        return;
                    }
                    await executeOperation(nextOperation, metadata);
                    let remainingSeconds = getRemainingSecondsInCycle();
                    if (remainingSeconds - nextOperation.delay_in_seconds < 30) {
                        return;
                    }

                    delayAfterPreviousAction = nextOperation.delay_in_seconds;
                }
            }

        } catch (e) {
            await reportException(e, metadata);
        } finally {
            cancelRunningExecutions = false;
            executeCycle = false;
            await endAutomationRun(metadata);
            await fireAutomationEnded(metadata);
        }
    }

    async function onAutomationScheduleDeleted() {
        cancelRunningExecutions = true;
    }

    function initBrokerSubscriptions() {
        backendBroker.subscribeToEvent(eventNames.automationScheduleTriggered, onAutomationScheduleTriggered);
        backendBroker.subscribeToEvent(eventNames.automationScheduleDeleted, onAutomationScheduleDeleted);
        backendBroker.subscribeToEvent(eventNames.extensionUpdating, onAutomationScheduleTriggered);
        backendBroker.subscribeForCommands(backendTopics.campaignsRunner, this);
    }

    const moduleResult = {

        isInWorkingHours: async function (args) {
            let snailyProfile = await getSnailyProfile(args.metadata);
            let targetSnailyProfile = snailyProfile.impersonatedPersona ?? snailyProfile;
            let preferTeamMemberHeaders = !!snailyProfile.impersonatedPersona;
            let result = await isInWorkingHours(targetSnailyProfile, preferTeamMemberHeaders, args.metadata);
            return result;
        },

        initBrokerSubscriptions: initBrokerSubscriptions
    };

    return moduleResult;

})();

const subscriptionPlans = {
    trial: 'trial',
    pro: 'pro',
    team: 'team'
};

const linkedInAcceptTypes = {
    graphql: "application/graphql",
    normalizedJson: "application/vnd.linkedin.normalized+json+2.1",
    json: "application/json",
    images: "image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8",
    all: "*/*"
};

const linkedInConst = {
    csrfToken: 'csrf-token'};

var localStorageModule = (function () {

    let _runtime;
    let signedInPersonaJwtKey = "jwt";
    let impersonatedPersonaJwtKey = "impersonated_jwt";
    let headersKey = "headers";
    let salesNavigatorHeaders = "salesNavigatorHeaders";
    let pendingCommandsKey = "pendingCommand";

    let mutex = Mutex();
    let signedInLinkedInUserMutex = Mutex();

    let signedInLinkedInUser = {
        csrfToken: null,
        profile: null
    };

    let chromeRuntime = new ChromeRuntimeAdapter();

    /**
     * @typedef {Object} IdToken
     * @property {string} linkedin_given_name
     * @property {string} linkedin_family_name
     * @property {string} linkedin_picture_url
     * @property {string} linkedin_object_id
     * @property {string} given_name
     * @property {string} family_name
     * @property {'true'|'false'} on_boarding
     * @property {'true'|'false'} is_beta_user
     * @property {'true'|'false'} running_activities_enabled
     * @property {'true'|'false'} running_activities_set
     * @property {'true'|'false'} working_hours_set
     * @property {string} running_activities_hint
     * @property {number} timezone_offset
     * @property {'true'|'false'} exceed_linkedin_invitations_limit
     * @property {string} subscription_plan_id
     * @property {'true'|'false'} subscription_is_active
     * @property {number} subscription_next_charge_date
     * @property {string} subscription_state
     * @property {string} log_level
     * @return {IdToken}
     */
    function decodeJwtToken(token) {
        //var encoded = token.split('.')[1];
        //var decoded = atob(encoded);
        //var result = JSON.parse(decoded);
        let result = o(token);
        return result;
    }

    async function getSignedInPersonaJwtTokens() {
        let serializedJwtTokens = await _runtime.getLocalStorageItemAsync(signedInPersonaJwtKey);
        if (serializedJwtTokens != null) {
            const result = JSON.parse(serializedJwtTokens);
            return result;
        }

        return null;
    }

    async function deleteSignedInPersonaJwtTokens() {
        await _runtime.removeLocalStorageItemAsync(signedInPersonaJwtKey);
    }

    async function saveSignedInPersonaJwtToken(jwtTokens) {
        let strJwt = JSON.stringify(jwtTokens);
        await _runtime.setLocalStorageItemAsync(signedInPersonaJwtKey, strJwt);
    }

    async function getImpersonatedPersonaJwtTokens() {
        let serializedJwtTokens = await _runtime.getLocalStorageItemAsync(impersonatedPersonaJwtKey);
        if (serializedJwtTokens != null) {
            const result = JSON.parse(serializedJwtTokens);
            return result;
        }

        return null;
    }

    async function deleteImpersonatedPersonaJwtTokens() {
        await _runtime.removeLocalStorageItemAsync(impersonatedPersonaJwtKey);
    }

    async function saveImpersonatedPersonaJwtTokens(jwtTokens) {
        let strJwt = JSON.stringify(jwtTokens);
        await _runtime.setLocalStorageItemAsync(impersonatedPersonaJwtKey, strJwt);
    }

    async function getAssociatedLinkedInProfile() {
        let jwtTokens = await getSignedInPersonaJwtTokens();
        let result = null;
        if (jwtTokens != null) {
            const idToken = decodeJwtToken(jwtTokens.id_token);
            result = decodeLinkedInProfile(idToken);
        }

        //result = {
        //    token: "ajax:8919719513721438081",
        //    publicIdentifier: "kirill-selyak-11aa6441"
        //};

        return result;
    }

    async function onLinkedInSignedOut() {
        await _runtime.removeLocalStorageItemAsync(headersKey);
        resetCachedSignedInLinkedInUser();
    }

    function isActivePlan(idToken, plan) {
        let result = idToken.subscription_plan_id === plan && idToken.subscription_is_active === "true";
        return result;
    }

    function isProPlanAccessible(idToken, accessToken) {
        // such permissions are granted to trial users 
        let hasProRights = accessToken.permissions.includes("workspace.write.pro");

        let activeProPlan = isActivePlan(idToken, subscriptionPlans.pro);
        let activeTeamPlan = isTeamPlanAccessible(idToken, accessToken);
        let result = hasProRights || activeProPlan || activeTeamPlan;
        return result;
    }

    function isTeamPlanAccessible(idToken, accessToken) {
        // such permissions are granted to trial users
        let hasTeamRights = accessToken.permissions.includes("workspace.write.team");

        let atLeastManager = isActivePlan(idToken, subscriptionPlans.team);
        let result = hasTeamRights || atLeastManager;
        return result;
    }

    function decodeLinkedInProfile(idToken) {
        let result = idToken.linkedin_public_identifier != null ?
            {
                id: idToken.sub,
                publicIdentifier: idToken.linkedin_public_identifier,
                givenName: idToken.linkedin_given_name,
                familyName: idToken.linkedin_family_name,
                pictureUrl: idToken.linkedin_picture_url,
                objectId: idToken.linkedin_object_id,
                entityId: idToken.linkedin_entity_id,
                publicProfileUrl: `https://www.linkedin.com/in/${idToken.linkedin_public_identifier}/`,
                linkedInProfileUrl: `https://www.linkedin.com/in/${idToken.linkedin_entity_id}/`
            } : null;
        return result;
    }

    function decodePersona(jwtTokens) {
        const idToken = decodeJwtToken(jwtTokens.id_token);
        const accessToken = decodeJwtToken(jwtTokens.access_token);
        let result = {
            id: idToken.sub,
            personaId: idToken.personaId,
            givenName: idToken.given_name,
            familyName: idToken.family_name,
            email: idToken.email,
            onBoarding: idToken.on_boarding === "true",
            isBetaUser: idToken.is_beta_user === "true",
            runningActivitiesEnabled: idToken.running_activities_enabled === "true",
            runningActivitiesSet: idToken.running_activities_set === "true",
            runningActivitiesHint: idToken.running_activities_hint
                ? idToken.running_activities_hint
                : "",
            timezoneOffset: idToken.timezone_offset
                ? parseInt(idToken.timezone_offset)
                : null,
            workingHoursSet: idToken.working_hours_set === "true",
            exceedLinkedInInvitationsLimit: idToken.exceed_linkedin_invitations_limit === "true",
            isTrial: idToken.subscription_plan_id === subscriptionPlans.trial,
            subscriptionPlanId: idToken.subscription_plan_id,
            subscriptionOwnerId: idToken.subscription_owner_id
                ? idToken.subscription_owner_id
                : null,
            subscriptionNextChargeDate: utils.toDateFromIso8651(idToken.subscription_next_charge_date),
            subscriptionActivationDate: utils.toDateFromIso8651(idToken.subscription_activation_date),
            subscriptionIsActive: idToken.subscription_is_active === "true",
            subscriptionState: idToken.subscription_state,
            isProPlanAccessible: isProPlanAccessible(idToken, accessToken),
            isTeamPlanAccessible: isTeamPlanAccessible(idToken, accessToken),
            teamId: idToken.team_id ? idToken.team_id : null,
            teamRole: idToken.team_role ? idToken.team_role : null,
            accessTokenExpiresAt: new Date(jwtTokens.access_token_expires_at),
            linkedInProfile: decodeLinkedInProfile(idToken),
            proxy: idToken.proxy_address
                ? {
                    address: idToken.proxy_address,
                    port: parseInt(idToken.proxy_port),
                    username: idToken.proxy_username,
                    password: idToken.proxy_password
                }
                : null,
            isBackendAutomation: idToken.use_backend_automation === "true",
            enableProfiles: idToken.enable_profiles === "true",
            isOpsSession: idToken.ops_session === "true",
            settings: {
                gettingRecentJobsIsBlocking: idToken.getting_recent_jobs_is_blocking === "true"
            }
        };
        return result;
    }

    async function getSnailyProfileWithoutCheckingSignedInLinkedInUser() {
        let signedInPersonaJwtTokens = await getSignedInPersonaJwtTokens();
        let result = null;
        if (signedInPersonaJwtTokens) {
            result = decodePersona(signedInPersonaJwtTokens);
            let impersonatedPersonaJwtTokens = await getImpersonatedPersonaJwtTokens();
            result.impersonatedPersona = impersonatedPersonaJwtTokens
                ? decodePersona(impersonatedPersonaJwtTokens)
                : null;

            if (result.runningActivitiesEnabled) {
                const idToken = decodeJwtToken(signedInPersonaJwtTokens.id_token);
                if (idToken.extension_update_required === "true") {
                    result.runningActivitiesEnabled = false;
                    result.runningActivitiesHint = "There is newer extension version. Please, update it to proceed.";
                }
            }
        }

        return result;
    }

    async function getSnailyProfile(args) {
        let result = await getSnailyProfileWithoutCheckingSignedInLinkedInUser();
        if (result?.runningActivitiesEnabled && args.checkSignedInLinkedInUser) {
            const associatedLinkedInProfile = await getAssociatedLinkedInProfile();
            const signedInLinkedInProfile = await getSignedInLinkedInUser(args);
            if (!(signedInLinkedInProfile && signedInLinkedInProfile.entityId === associatedLinkedInProfile.entityId)) {
                result.runningActivitiesEnabled = false;
                result.runningActivitiesHint = "Please, sign-in to LinkedIn with the account registered at Snaily.";
            }
        }

        return result;
    }

    async function getLinkedInCookies(metadata) {
        let command = backendCommandsFactory.cookies.createGetLinkedInCookies(metadata);
        const result = await backendBroker.publish(command);
        return result;
    }

    async function getNotCachedSignedInLinkedInUser(headers, metadata) {
        let profile = await getSnailyProfileWithoutCheckingSignedInLinkedInUser();
        let command = null;
        if (profile?.isBackendAutomation) {
            let cookies = await getLinkedInCookies(metadata);
            command = backendCommandsFactory.apiProxy.backendAutomation.createGetCurrentProfile(cookies, headers, metadata);
        } else {
            command = backendCommandsFactory.linkedInProxy.authorize.V2.createGetCurrentProfile(headers, metadata);
        }

        try {
            let result = await backendBroker.publish(command);
            return result;
        } catch (error) {
            // weird logging, though ... 
            if (!error.skipLogging && !(error instanceof LinkedInSignInRequiredError)) {
                const parameters = errorParametersFactory.create(error);
                await reportError(logEntryIds.unhandledError, parameters);
            }
            return null;
        }
    }

    function resetCachedSignedInLinkedInUser() {
        signedInLinkedInUser.csrfToken = null;
        signedInLinkedInUser.profile = null;
    }

    async function getLastLinkedInRequestHeaders(metadata) {
        let serializedJson = await _runtime.getLocalStorageItemAsync(headersKey);
        if (serializedJson != null) {
            const result = JSON.parse(serializedJson);
            return result.headers;
        }

        return null;
    }

    async function getCachedSignedInLinkedInUserAsync(headers, metadata) {
        if (!headers || !headers[linkedInConst.csrfToken]) {
            resetCachedSignedInLinkedInUser();
        } else if (headers[linkedInConst.csrfToken] !== signedInLinkedInUser.csrfToken) {
            let jsSessionId = await chromeRuntime.geCookies("JSESSIONID");
            if (!jsSessionId) {
                jsSessionId = null;
            }
            signedInLinkedInUser.csrfToken = jsSessionId;
        }

        // retry every time, it might happens that getting current profile could be terminated because of bad connection 
        if (signedInLinkedInUser.csrfToken && !signedInLinkedInUser.profile) {
            signedInLinkedInUser.profile = await getNotCachedSignedInLinkedInUser(headers, metadata);
        }

        return signedInLinkedInUser.profile;
    }

    async function reportError(error, metadata) {
        if (error.skipLogging) {
            return;
        }
        const parameters = errorParametersFactory.create(error);
        let message = backendCommandsFactory.logging.createLogError(logEntryIds.unhandledError, parameters, metadata);
        await backendBroker.publish(message);
    }

    async function getSignedInLinkedInUser(args) {
        await signedInLinkedInUserMutex.lock();
        try {
            const headers = await getLastLinkedInRequestHeaders(args.metadata);
            if (headers) {
                headers.Referer = 'https://www.linkedin.com/feed/';
                headers.Accept = linkedInAcceptTypes.normalizedJson;
            }

            let result = await getCachedSignedInLinkedInUserAsync(headers, args.metadata);
            return result;
        } finally {
            await signedInLinkedInUserMutex.release();
        }
    }

    async function getAccessTokens(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetAccessToken(metadata);
        let result = await backendBroker.publish(command);
        return result;
    }

    const moduleResult = {

        getSnailyProfile: async function (args) {
            await mutex.lock();
            try {
                try {
                    // it will refresh tokens if they are expired 
                    await getAccessTokens();
                } catch (error) {
                    //todo: looks smelling, let it be as it is because there is no harm 
                    await reportError(error, args.metadata);
                }
                let result = await getSnailyProfile(args);
                return result;
            } finally {
                await mutex.release();
            }
        },

        getLatestKnownSnailyProfile: async function (args) {
            let result = await getSnailyProfile(args);
            return result;
        },

        getUserLogLevel: async function () {
            const jwtTokens = await getSignedInPersonaJwtTokens();
            let result = null;
            if (jwtTokens) {
                const accessToken = decodeJwtToken(jwtTokens.id_token);
                result = accessToken.log_level;
            }

            return result;
        },

        getLinkedInProfile: getAssociatedLinkedInProfile,

        getSignedInPersonaJwtTokens: getSignedInPersonaJwtTokens,

        saveSignedInPersonaJwtTokens: async function (args) {
            await saveSignedInPersonaJwtToken(args.parameter.jwtTokens);
        },

        deleteSignedInPersonaJwtTokens: deleteSignedInPersonaJwtTokens,

        getImpersonatedPersonaJwtTokens: getImpersonatedPersonaJwtTokens,

        saveImpersonatedPersonaJwtTokens: async function (args) {
            await saveImpersonatedPersonaJwtTokens(args.parameter.jwtTokens);
        },

        deleteImpersonatedPersonaJwtTokens: deleteImpersonatedPersonaJwtTokens,

        saveLinkedInHeaders: async function (args) {
            let strJwt = JSON.stringify(args.parameter.headers);
            await _runtime.setLocalStorageItemAsync(headersKey, strJwt);
        },

        getLinkedInHeaders: async function () {
            let result = await getLastLinkedInRequestHeaders();
            return result;
        },

        saveSalesNavigatorHeaders: async function (args) {
            let strJwt = JSON.stringify(args.parameter.headers);
            await _runtime.setLocalStorageItemAsync(salesNavigatorHeaders, strJwt);
        },

        getSalesNavigatorHeaders: async function () {
            let serializedJson = await _runtime.getLocalStorageItemAsync(salesNavigatorHeaders);
            if (serializedJson != null) {
                const result = JSON.parse(serializedJson);
                return result.headers;
            }

            return null;
        },

        savePendingCommands: async function (args) {
            let str = JSON.stringify(args.parameter.commands);
            await _runtime.setLocalStorageItemAsync(pendingCommandsKey, str);
        },

        deletePendingCommands: async function () {
            await _runtime.removeLocalStorageItemAsync(pendingCommandsKey);
        },

        getPendingCommands: async function () {
            let strValue = await _runtime.getLocalStorageItemAsync(pendingCommandsKey);
            if (strValue != null) {
                const result = JSON.parse(strValue);
                return result;
            }

            return null;
        },

        getSignedInLinkedInUser: getSignedInLinkedInUser,

        initBrokerSubscriptions: function (runtime) {
            _runtime = runtime;
            backendBroker.subscribeForCommands(backendTopics.localStorage, this);
            backendBroker.subscribeToEvent(eventNames.linkedInSignedOut, onLinkedInSignedOut);
        }
    };

    return moduleResult;

})
();

class BackgroundChromeRuntimeEmulator {

    constructor() {
    }

    async sendMessage(command) {
        throw new Error("Invalid flow, function sendMessage is not supported");
    }

    async sendTabMessage(args) {
        throw new Error("Invalid flow, function sendTabMessage is not supported");
    }

    async sendExtensionMessage(extensionId, message) {
        throw new Error("Invalid flow, function sendExtensionMessage is not supported");
    }

    async createTab(url) {
        throw new Error("Invalid flow, function createTab is not supported");
    }

    async clearAlarm(name) {
        throw new Error("Invalid flow, function clearAlarm is not supported");
    }

    async getAlarm(name) {
        throw new Error("Invalid flow, function getAlarm is not supported");
    }

    async getSelectedTab() {
        throw new Error("Invalid flow, function getSelectedTab is not supported");
    }

    async getTab(id) {
        throw new Error("Invalid flow, function getTab is not supported");
    }

    async reloadTab(id) {
        throw new Error("Invalid flow, function reloadTab is not supported");
    }

    async queryTabs() {
        throw new Error("Invalid flow, function queryTabs is not supported");
    }

    async createAlarm(name, delayInMinutes, periodInMinutes) {
        throw new Error("Invalid flow, function createAlarm is not supported");
    }

    async createNotification(notificationId, options) {
        throw new Error("Invalid flow, function createNotification is not supported");
    }

    async setIcon(path) {
        throw new Error("Invalid flow, function setIcon is not supported");
    }

    async setBadgeText(text) {
        throw new Error("Invalid flow, function setBadgeText is not supported");
    }

    async setBadgeBackgroundColor(color) {
        throw new Error("Invalid flow, function setBadgeBackgroundColor is not supported");
    }

    async getProxyConfig() {
        throw new Error("Invalid flow, function getProxyConfig is not supported");
    }

    async setProxyConfig(proxyConfig) {
        throw new Error("Invalid flow, function setProxyConfig is not supported");
    }

    async clearProxyConfig() {
        throw new Error("Invalid flow, function clearProxyConfig is not supported");
    }

    reload() {
        throw new Error("Invalid flow, function reload is not supported");
    }

    addOnMessageListener(listener) {
        throw new Error("Invalid flow, function addOnMessageListener is not supported");
    }

    addOnExternalMessageListener(listener) {
        throw new Error("Invalid flow, function addOnExternalMessageListener is not supported");
    }

    addAlarmListener(listener) {
        throw new Error("Invalid flow, function addAlarmListener is not supported");
    }

    addOnInstalledListener(listener) {
        throw new Error("Invalid flow, function addOnInstalledListener is not supported");
    }

    addOnStartupListener(listener) {
        throw new Error("Invalid flow, function addOnStartupListener is not supported");
    }

    addOnTabRemovedListener(listener) {
        throw new Error("Invalid flow, function addOnTabRemovedListener is not supported");
    }

    addOnTabCreatedListener(listener) {
        throw new Error("Invalid flow, function addOnTabCreatedListener is not supported");
    }

    addOnTabReplacedListener(listener) {
        throw new Error("Invalid flow, function addOnTabReplacedListener is not supported");
    }

    addOnTabUpdatedListener(listener) {
        throw new Error("Invalid flow, function addOnTabUpdatedListener is not supported");
    }

    addOnWebRequestBeforeSendHeadersListener(listener, urls, options) {
        throw new Error("Invalid flow, function addOnWebRequestBeforeSendHeadersListener is not supported");
    }

    addOnWebRequestCompletedListener(listener, urls, options) {
        throw new Error("Invalid flow, function addOnWebRequestCompletedListener is not supported");
    }

    addOnWebRequestBeforeRedirectListener(listener, urls, options) {
        throw new Error("Invalid flow, function addOnWebRequestBeforeRedirectListener is not supported");
    }

    addOnWebRequestErrorOccurredListener(listener, urls, options) {
        throw new Error("Invalid flow, function addOnWebRequestErrorOccurredListener is not supported");
    }

    addOnNotificationButtonClickedListener(listener) {
        throw new Error("Invalid flow, function addOnNotificationButtonClickedListener is not supported");
    }

    addOnNotificationClickedListener(listener) {
        throw new Error("Invalid flow, function addOnNotificationClickedListener is not supported");
    }

    addOnUpdateAvailableListener(listener) {
        throw new Error("Invalid flow, function addOnUpdateAvailableListener is not supported");
    }

    addOnProxyErrorListener(listener) {
        throw new Error("Invalid flow, function addOnProxyErrorListener is not supported");
    }

    removeOnProxyErrorListener(listener) {
        throw new Error("Invalid flow, function removeOnProxyErrorListener is not supported");
    }

    addOnAuthRequiredListener(listener, urls, options) {
        throw new Error("Invalid flow, function addOnAuthRequiredListener is not supported");
    }

    removeOnAuthRequiredListener(listener) {
        throw new Error("Invalid flow, function removeOnAuthRequiredListener is not supported");
    }

    getName() {
        throw new Error("Invalid flow, function getName is not supported");
    }

    getVersion() {
        return "5.0.0.0";
    }

    getId() {
        throw new Error("Invalid flow, function getName is not supported");
    }

    async getLocalStorageItemAsync(key) {
        let storageItem = window.localStorage.getItem(key);
        let result = storageItem
            ? storageItem
            : null;
        return result;
    }

    async setLocalStorageItemAsync(key, value) {
        window.localStorage.setItem(key, value);
    }

    async removeLocalStorageItemAsync(key) {
        window.localStorage.removeItem(key);
    }

    async powerRequestSystemKeepAwake() {
        throw new Error("Invalid flow, function powerRequestSystemKeepAwake is not supported");
    }

    async getAllCookies() {
        throw new Error("Invalid flow, function getAllCookies is not supported");
    }

    async geCookies(name) {
        throw new Error("Invalid flow, function getAllCookies is not supported");
    }
}

var oauthModule = (function () {

    function initBrokerSubscriptions() {
        backendBroker.subscribeForCommands(backendTopics.oauth, this);
    }

    let moduleResult = {

        getSigninUri: async function (args) {
            let result = `${config.oauth.signin_uri}` +
                `?client_id=${config.oauth.client_id}` +
                `&redirect_uri=${config.oauth.redirect_uri}` +
                `&scope=Persona.FullAccess` +
                `&access_type=offline`;
            if (args.parameter.referrer) {
                result += `&referrer=${args.parameter.referrer}`;
            }
            if (args.parameter.state) {
                result += `&state=${args.parameter.state}`;
            }
            return result;
        },

        signOut: async function (args) {
            let revokeCommand = backendCommandsFactory.apiProxy.createRevokeToken(args.metadata);
            await backendBroker.publish(revokeCommand);
        },

        initBrokerSubscriptions: initBrokerSubscriptions

    };

    return moduleResult;

})();

const eventsRouterModule = (function () {

        async function broadcastEvent(event) {
            const customEvent = new CustomEvent('SnailyEvent', {detail: event});
            document.dispatchEvent(customEvent);
        }

        async function onLinkedInSignedOut(args) {
            let linkedInSignedOut = backendEventsFactory.createLinkedInSignedOut(args.parameter.reason, args.parameter.details, args.metadata);
            await broadcastEvent(linkedInSignedOut);

            let snailyProfileChanged = backendEventsFactory.createSnailyProfileChanged(args.metadata);
            await broadcastEvent(snailyProfileChanged);
        }

        async function onLinkedInProfileDetected(args) {
            let event = backendEventsFactory.createLinkedInProfileDetected(args.parameter.linkedInProfile, args.metadata);
            await broadcastEvent(event);

            let snailyProfileChanged = backendEventsFactory.createSnailyProfileChanged(args.metadata);
            await broadcastEvent(snailyProfileChanged);
        }

        async function onSnailySignedOut(args) {
            let event = backendEventsFactory.createSnailySignedOut(args.metadata);
            await broadcastEvent(event);
        }

        async function onSnailySignedIn(args) {
            let event = backendEventsFactory.createSnailySignedIn(args.metadata);
            await broadcastEvent(event);
        }

        async function onSnailyProfileChanged(args) {
            let event = backendEventsFactory.createSnailyProfileChanged(args.metadata);
            await broadcastEvent(event);
        }

        async function onAutomationEnded(args) {
            let event = backendEventsFactory.createAutomationEnded(args.metadata);
            await broadcastEvent(event);
        }

        async function onExportStarting(args) {
            let event = backendEventsFactory.createExportStarting(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onExportStarted(args) {
            let event = backendEventsFactory.createExportStarted(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onExportCleared(args) {
            let event = backendEventsFactory.createExportCleared(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onExportChanged(args) {
            let event = backendEventsFactory.createExportChanged(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onExportFailed(args) {
            let event = backendEventsFactory.createExportFailed(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onExportCompleting(args) {
            let event = backendEventsFactory.createExportCompleting(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onExportCompleted(args) {
            let event = backendEventsFactory.createExportCompleted(args.parameter, args.metadata);
            await broadcastEvent(event);
        }

        async function onWorkingHoursChanged(args) {
            let event = backendEventsFactory.createWorkingHoursChanged(args.metadata);
            await broadcastEvent(event);
        }

        function initBrokerSubscriptions() {
            //Important: Init must be synchronous otherwise popup could send a request to backend earlier then backend is initialized
            //It might reproduce the issue #1260 if you try to open popup immediately after extension is loaded, reloaded or was inactive   
            backendBroker.subscribeToEvent(eventNames.linkedInSignedOut, onLinkedInSignedOut);
            backendBroker.subscribeToEvent(eventNames.linkedInProfileDetected, onLinkedInProfileDetected);
            backendBroker.subscribeToEvent(eventNames.snailySignedOut, onSnailySignedOut);
            backendBroker.subscribeToEvent(eventNames.snailySignedIn, onSnailySignedIn);
            backendBroker.subscribeToEvent(eventNames.snailyProfileChanged, onSnailyProfileChanged);
            backendBroker.subscribeToEvent(eventNames.automationEnded, onAutomationEnded);
            backendBroker.subscribeToEvent(eventNames.exportStarting, onExportStarting);
            backendBroker.subscribeToEvent(eventNames.exportStarted, onExportStarted);
            backendBroker.subscribeToEvent(eventNames.exportCleared, onExportCleared);
            backendBroker.subscribeToEvent(eventNames.exportChanged, onExportChanged);
            backendBroker.subscribeToEvent(eventNames.exportFailed, onExportFailed);
            backendBroker.subscribeToEvent(eventNames.exportCompleting, onExportCompleting);
            backendBroker.subscribeToEvent(eventNames.exportCompleted, onExportCompleted);
            backendBroker.subscribeToEvent(eventNames.workingHoursChanged, onWorkingHoursChanged);
        }

        return {
            initBrokerSubscriptions: initBrokerSubscriptions
        }
    }

)
();

var backendConnectorFactory = function (extensionId) {
    runtimeAdapterFactory();
    let _suppressSnailyEvents = false;
    const _eventHandlers = {};

    let _currentLinkedInProfileDetectedResolver;
    let _popup;

    async function sendMessage(message) {
        const result = await backendBroker.publish(message);
        return result;
    }

    async function sendMessageInternally(command) {
        const result = await backendBroker.publish(command);
        return result;
    }

    function resetCapturingLinkedInProfile() {
        if (_popup) {
            _popup.close();
        }

        _currentLinkedInProfileDetectedResolver = null;
        _popup = null;
    }

    function onLinkedInProfileDetectedHandler() {
        try {
            if (_currentLinkedInProfileDetectedResolver) {
                _currentLinkedInProfileDetectedResolver();
            }
        } finally {
            resetCapturingLinkedInProfile();
        }
    }

    function addEventHandler(eventName, handler) {
        if (!_eventHandlers[eventName]) {
            _eventHandlers[eventName] = [];
        }

        _eventHandlers[eventName].push(handler);
    }

    function removeEventHandler(eventName) {
        _eventHandlers[eventName] = [];
    }

    function composeAutomationApiV2Uri(relativeUri) {
        let result = `${config.backend.automation_endpoint}v2/${relativeUri}`;
        return result;
    }
    
    async function getSnailyProfile(metadata) {
        if (!metadata) {
            metadata = metadataFactory.create();
        }

        let command = backendCommandsFactory.localStorage.createGetSnailyProfile(metadata);
        let result = await sendMessage(command);
        return result;
    }

    async function createApiHeaders(metadata) {
        const result = {
            'Content-Type': 'application/json',
            'authorization': await getAccessToken(metadata)
        };
        return result;
    }

    async function getAccessToken(metadata) {
        try {
            const command = backendCommandsFactory.apiProxy.createGetAccessToken(metadata);
            const result = await sendMessage(command);
            return result;
        } catch (exp) {
            if (exp instanceof MissingReceiverExtensionRuntimeError) {
                throw new ExtensionNotInstalledError("Extension is not installed", metadata);
            }

            throw exp;
        }
    }

    async function getSignedInLinkedInProfile(metadata) {
        let apiUri = composeAutomationApiV2Uri(`me`);
        const response = await httpRequest(apiUri,
            {
                method: 'GET',
                headers: await createApiHeaders(metadata)
            }, metadata);

        await backendLinkedInApiErrorHandler.guard(response, metadata);
        let result = await response.json();
        return result;
    }

    async function getAssociatedLinkedInProfile(metadata) {
        let command = backendCommandsFactory.localStorage.createGetLinkedInProfile(metadata);
        let result = await sendMessage(command);
        return result;
    }

    async function exchangeAuthorizationCode(code, metadata) {
        let command = backendCommandsFactory.apiProxy.createExchangeAuthorizationCode(code, metadata);
        await sendMessage(command);
    }

    async function addLinkedInProfile(profile, metadata) {
        let command = backendCommandsFactory.apiProxy.createAddLinkedInProfile(profile, metadata);
        let result = await sendMessageInternally(command);
        return result;
    }

    async function getLinkedInProfiles(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetLinkedInProfiles(metadata);
        const result = await sendMessageInternally(command);
        return result;
    }

    async function broadcastSnailyEvent(snailyEvent) {
        if (_eventHandlers[snailyEvent.event]) {
            for (const handler of _eventHandlers[snailyEvent.event]) {
                if (await handler(snailyEvent.event.args)) {
                    return;
                }
            }
        }
    }

    document.addEventListener("SnailyEvent", async function (e) {
        if (!_suppressSnailyEvents) {
            await broadcastSnailyEvent(e.detail);
        }
    });

    addEventHandler(eventNames.linkedInProfileDetected, onLinkedInProfileDetectedHandler);

    async function isInWorkingHours(metadata) {
        let command = backendCommandsFactory.campaignsRunner.createIsInWorkingHours(metadata);
        let result = await sendMessageInternally(command);
        return result;
    }

    const factory = {

        auth: {

            signIn: async function (state, referrer, metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }
                if (!referrer || referrer === '') {
                    referrer = '<none>';
                }

                let message = backendCommandsFactory.auth.createGetSignInUri(state, referrer, metadata);
                const uri = await sendMessage(message);
                window.open(uri, "_self");
            },

            signOut: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let message = backendCommandsFactory.auth.createSignOut(metadata);
                await sendMessage(message);
            },

            getSnailyProfile: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let result = await getSnailyProfile(metadata);
                return result;
            },

            getAssociatedLinkedInProfile: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let result = await getAssociatedLinkedInProfile(metadata);
                return result;
            },

            exchangeAuthorizationCode: async function (code, metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                await exchangeAuthorizationCode(code, metadata);
            },

            getAccessToken: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let result = await getAccessToken(metadata);
                return result;
            },

            refreshAccessToken: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                const command = backendCommandsFactory.apiProxy.createRefreshAuthTokens(metadata);
                await sendMessage(command);
            },

            switchToWorkspace: async function (linkedInProfileId, metadata) {
                if (!linkedInProfileId) {
                    throw new Error('Argument - linkedInProfileId is not set.');
                }

                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let command = backendCommandsFactory.apiProxy.createSwitchToWorkspace(linkedInProfileId, metadata);
                await sendMessage(command);
            },

            signInUnderTeamMember: async function (personaId, metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let command = backendCommandsFactory.apiProxy.createSignInUnderTeamMember(personaId, metadata);
                await sendMessage(command);
            },

            signOutUnderTeamMember: async function (personaId, metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let command = backendCommandsFactory.apiProxy.createSignOutUnderTeamMember(metadata);
                await sendMessage(command);
            }

        },

        automation: {

            isInWorkingHours: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let result = await isInWorkingHours(metadata);
                return result;
            }

        },

        linkedIn: {

            getCurrentProfile: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                let result = await getSignedInLinkedInProfile(metadata);
                return result;
            },

            // outdated
            captureCurrentProfile: async function (duration, metadata) {
                throw new Error("Invalid execution flow  for function linkedIn.captureCurrentProfile");
            },

            // extension specific function
            getSettings: async function (metadata) {
                throw new Error("Invalid execution flow  for function linkedIn.getSettings");
            },

            mailboxes: {

                // extension specific function
                archive: {

                    // extension specific function
                    getRecentConversations: async function (metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.archive.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.archive.getNextConversations");
                    }
                },

                // extension specific functions
                focused: {

                    // extension specific function
                    getRecentConversations: async function (metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.focused.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.focused.getNextConversations");
                    }
                },

                // extension specific functions
                inbox: {

                    // extension specific function
                    getRecentConversations: async function (metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.inbox.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.inbox.getNextConversations");
                    }
                },

                // extension specific functions
                inMail: {

                    // extension specific function
                    getRecentConversations: async function (mailboxType, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.inMail.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.inMail.getNextConversations");
                    }
                },

                // extension specific functions
                myConnections: {

                    // extension specific function
                    getRecentConversations: async function (mailboxType, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.myConnections.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.myConnections.getNextConversations");
                    }
                },

                // extension specific functions
                other: {

                    // extension specific function
                    getRecentConversations: async function (metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.other.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.other.getNextConversations");
                    }
                },

                // extension specific functions
                search: {

                    // extension specific function
                    getRecentConversations: async function (keywords, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.search.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (keywords, nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.search.getNextConversations");
                    }
                },

                // extension specific functions
                starred: {

                    // extension specific function
                    getRecentConversations: async function (mailboxType, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.starred.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.starred.getNextConversations");
                    }
                },

                // extension specific functions
                unread: {

                    // extension specific function
                    getRecentConversations: async function (mailboxType, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.unread.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.unread.getNextConversations");
                    }
                },

                // extension specific functions
                spam: {

                    // extension specific function
                    getRecentConversations: async function (metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.spam.getRecentConversations");
                    },

                    // extension specific function
                    getNextConversations: async function (nextCursor, metadata) {
                        throw new Error("Invalid execution flow  for function linkedIn.mailboxes.spam.getNextConversations");
                    }
                },
            },

            // extension specific functions
            messaging: {

                getUnreadConversationsCounters: async function (metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.messaging.getUnreadConversationsCounters");
                }
            },

            // extension specific functions
            conversations: {

                // extension specific function
                getConversationRecentEvents: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.getConversationRecentEvents");
                },

                // extension specific function
                getConversationNextEvents: async function (conversationId, prevCursor, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.getConversationNextEvents");
                },

                // extension specific function
                getConversationAttachment: async function (conversationId, attachmentUrl, acceptHeader, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.getConversationAttachment");
                },

                // extension specific function
                deleteConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.deleteConversation");
                },

                // extension specific function
                deleteConversationEvent: async function (conversationId, eventId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.deleteConversationEvent");
                },

                // extension specific function
                starConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.starConversation");
                },

                // extension specific function
                unstarConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.unstarConversation");
                },

                // extension specific function
                archiveConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.archiveConversation");
                },

                // extension specific function
                unarchiveConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.unarchiveConversation");
                },

                // extension specific function
                moveConversationToOtherMailbox: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.moveConversationToOtherMailbox");
                },

                // extension specific function
                moveConversationToFocusedMailbox: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.moveConversationToFocusedMailbox");
                },

                // extension specific function
                readConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.readConversation");
                },

                // extension specific function
                unreadConversation: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.unreadConversation");
                },

                // extension specific function
                changeConversationEvent: async function (conversationId, eventId, text, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.changeConversationEvent");
                },

                // extension specific function
                createConversationEvent: async function (conversationId, text, attachments, replyTo, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.createConversationEvent");
                },

                // extension specific function
                uploadConversationAttachment: async function (conversationId, attachment, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.uploadConversationAttachment");
                },

                // extension specific function
                addConversationEventReaction: async function (conversationId, eventId, emoji, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.addConversationEventReaction");
                },

                // extension specific function
                revokeConversationEventReaction: async function (conversationId, eventId, emoji, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.revokeConversationEventReaction");
                },

                // extension specific function
                getConversationParticipants: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.getConversationParticipants");
                },

                // extension specific function
                getConversationSeenReceipts: async function (conversationId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.conversations.getConversationSeenReceipts");
                }

            },

            // extension specific functions
            contacts: {

                // extension specific function
                getContactFullProfile: async function (entityId, metadata) {
                    throw new Error("Invalid execution flow  for function linkedIn.contacts.getContactFullProfile");
                }
            }

        },

        api: {

            getLinkedInProfiles: async function (metadata) {
                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                const result = await getLinkedInProfiles(metadata);
                return result;
            },

            addLinkedInProfile: async function (profile, metadata) {
                if (!profile) {
                    throw new Error('Argument - profile is not set.');
                }

                if (!metadata) {
                    metadata = metadataFactory.create();
                }

                const result = await addLinkedInProfile(profile, metadata);
                return result;
            },

            isCompatibleWithCurrentExtension: async function (metadata) {
                //stub
                return true;
            }
        },

        extension: {

            isInstalled: async function (metadata) {
                // stub
                return true;
            },

            getExtensionVersion: async function (metadata) {
                let result = "5.0.0.0";
                return result;
            }

        },

        utils: {

            createMetadata: function () {
                const result = metadataFactory.create();
                return result;
            }

        },

        eventHandlers: {

            suppressEvents: function () {
                _suppressSnailyEvents = true;
            },

            enableEvents: function () {
                _suppressSnailyEvents = false;
            },

            addLinkedInSignedOutEventHandler: function (handler) {
                addEventHandler(eventNames.linkedInSignedOut, handler);
            },

            addLinkedInProfileDetectedHandler: function (handler) {
                addEventHandler(eventNames.linkedInProfileDetected, handler);
            },

            addSnailySignedInEventHandler: function (handler) {
                addEventHandler(eventNames.snailySignedIn, handler);
            },

            addSnailySignedOutEventHandler: function (handler) {
                addEventHandler(eventNames.snailySignedOut, handler);
            },

            addSnailyProfileChangedEventHandler: function (handler) {
                addEventHandler(eventNames.snailyProfileChanged, handler);
            },

            addAutomationEndedEventHandler: function (handler) {
                addEventHandler(eventNames.automationEnded, handler);
            },

            removeAutomationEndedEventHandlers: function () {
                removeEventHandler(eventNames.automationEnded);
            },

            addWorkingHoursChangedHandler: function (handler) {
                addEventHandler(eventNames.workingHoursChanged, handler);
            },

            removeWorkingHoursChangedHandler: function (handler) {
                addEventHandler(eventNames.workingHoursChanged, handler);
            },

        },

        init: async function () {
            systemModuleStub.initBrokerSubscriptions();
            localStorageModule.initBrokerSubscriptions(new BackgroundChromeRuntimeEmulator());
            //extensionLocalStorageModule.initBrokerSubscriptions(_extensionId);
            loggingModule.initBrokerSubscriptions();
            apiProxyModule.initBrokerSubscriptions();
            campaignsModule.initBrokerSubscriptions();
            oauthModule.initBrokerSubscriptions();
            eventsRouterModule.initBrokerSubscriptions();
        }

    };

    return factory;

};

/* eslint-disable no-undef */

var connectorFactory = function (extensionId) {
    let _connector = null;
    let _correlationFactory = null;

    function getConnector(metadata) {
        if (!_connector) {
            throw new ExtensionNotInstalledError("Extension is not installed", metadata);
        }

        return _connector;
    }

    function setConnector(connector) {
        _connector = connector;
    }

    function validateMailboxType(mailboxType) {
        if (!(mailboxType === MailboxType.Inbox || mailboxType === MailboxType.Focused || mailboxType === MailboxType.Other)) {
            throw new Error(`Invalid mailbox type ${mailboxType}`);
        }
    }

    const factory = {

        auth: {

            signIn: async function (state, metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                const referrer = localStorage.getItem("referrer");
                await getConnector(metadata).auth.signIn(state, referrer, metadata);
            },

            signOut: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                await getConnector(metadata).auth.signOut(metadata);
            },

            getSnailyProfile: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).auth.getSnailyProfile(metadata);
                return result;
            },

            getAssociatedLinkedInProfile: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).auth.getAssociatedLinkedInProfile(metadata);
                return result;
            },

            exchangeAuthorizationCode: async function (code, metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                await getConnector(metadata).auth.exchangeAuthorizationCode(code, metadata);
            },

            getAccessToken: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                try {
                    const result = await getConnector(metadata).auth.getAccessToken(metadata);
                    return result;
                } catch (exp) {
                    if (exp.name === "ExtensionNotInstalledError") {
                        setConnector(null);
                    }

                    throw exp;
                }

            },

            refreshAccessToken: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                await getConnector(metadata).auth.refreshAccessToken(metadata);
            },

            switchToWorkspace: async function (linkedInProfileId, metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                await getConnector(metadata).auth.switchToWorkspace(linkedInProfileId, metadata);
            },

            signInUnderTeamMember: async function (personaId, metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                await getConnector(metadata).auth.signInUnderTeamMember(personaId, metadata);
            },

            signOutUnderTeamMember: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                await getConnector(metadata).auth.signOutUnderTeamMember(metadata);
            }

        },

        automation: {

            isInWorkingHours: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).automation.isInWorkingHours(metadata);
                return result;
            }

        },

        linkedIn: {

            getCurrentProfile: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).linkedIn.getCurrentProfile(metadata);
                return result;
            },

            captureCurrentProfile: async function (duration, metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).linkedIn.captureCurrentProfile(duration, metadata);
                return result;
            },

            getSettings: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).linkedIn.getSettings(metadata);
                return result;
            },

            mailboxes: {

                archive: {

                    getRecentConversations: async function (metadata) {
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.archive.getRecentConversations(metadata);
                        return result;
                    },

                    getNextConversations: async function (nextCursor, metadata) {
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.archive.getNextConversations(nextCursor, metadata);
                        return result;
                    }
                },

                focused: {

                    getRecentConversations: async function (metadata) {
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.focused.getRecentConversations(metadata);
                        return result;
                    },

                    getNextConversations: async function (nextCursor, metadata) {
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.focused.getNextConversations(nextCursor, metadata);
                        return result;
                    }
                },

                inbox: {

                    getRecentConversations: async function (metadata) {
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.inbox.getRecentConversations(metadata);
                        return result;
                    },

                    getNextConversations: async function (nextCursor, metadata) {
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.inbox.getNextConversations(nextCursor, metadata);
                        return result;
                    }
                },

                inMail: {

                    getRecentConversations: async function (mailboxType, metadata) {
                        validateMailboxType(mailboxType);
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.inMail.getRecentConversations(mailboxType, metadata);
                        return result;
                    },

                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        validateMailboxType(mailboxType);
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.inMail.getNextConversations(mailboxType, nextCursor, metadata);
                        return result;
                    }
                },

                myConnections: {

                    getRecentConversations: async function (mailboxType, metadata) {
                        validateMailboxType(mailboxType);
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.myConnections.getRecentConversations(mailboxType, metadata);
                        return result;
                    },

                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        validateMailboxType(mailboxType);
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.myConnections.getNextConversations(mailboxType, nextCursor, metadata);
                        return result;
                    }
                },

                other: {

                    getRecentConversations: async function (metadata) {
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.other.getRecentConversations(metadata);
                        return result;
                    },

                    getNextConversations: async function (nextCursor, metadata) {
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.other.getNextConversations(nextCursor, metadata);
                        return result;
                    }
                },

                search: {

                    getRecentConversations: async function (keywords, metadata) {
                        if (!keywords) {
                            throw new Error('keywords must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.search.getRecentConversations(keywords, metadata);
                        return result;
                    },

                    getNextConversations: async function (keywords, nextCursor, metadata) {
                        if (!keywords) {
                            throw new Error('keywords must be defined');
                        }

                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.search.getNextConversations(keywords, nextCursor, metadata);
                        return result;
                    }
                },

                starred: {

                    getRecentConversations: async function (mailboxType, metadata) {
                        validateMailboxType(mailboxType);
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.starred.getRecentConversations(mailboxType, metadata);
                        return result;
                    },

                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        validateMailboxType(mailboxType);
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.starred.getNextConversations(mailboxType, nextCursor, metadata);
                        return result;
                    }
                },

                unread: {

                    getRecentConversations: async function (mailboxType, metadata) {
                        validateMailboxType(mailboxType);

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.unread.getRecentConversations(mailboxType, metadata);
                        return result;
                    },

                    getNextConversations: async function (mailboxType, nextCursor, metadata) {
                        validateMailboxType(mailboxType);

                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.unread.getNextConversations(mailboxType, nextCursor, metadata);
                        return result;
                    }
                },

                spam: {

                    getRecentConversations: async function (metadata) {
                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.spam.getRecentConversations(metadata);
                        return result;
                    },

                    getNextConversations: async function (nextCursor, metadata) {
                        if (!nextCursor) {
                            throw new Error('nextCursor must be defined');
                        }

                        if (!metadata) {
                            metadata = _correlationFactory();
                        }

                        let connector = getConnector(metadata);
                        let result = await connector.linkedIn.mailboxes.spam.getNextConversations(nextCursor, metadata);
                        return result;
                    }
                },
            },

            messaging: {

                getUnreadConversationsCounters: async function (metadata) {
                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.messaging.getUnreadConversationsCounters(metadata);
                    return result;
                }
            },

            conversations: {

                getConversationRecentEvents: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.getConversationRecentEvents(
                        conversationId,
                        metadata);
                    return result;
                },

                getConversationNextEvents: async function (conversationId, prevCursor, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!conversationId) {
                        throw new Error('prevCursor must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.getConversationNextEvents(
                        conversationId,
                        prevCursor,
                        metadata);
                    return result;
                },

                getConversationAttachment: async function (conversationId, attachmentUrl, acceptHeader, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!attachmentUrl) {
                        throw new Error('attachmentUrl must be defined');
                    }

                    if (!acceptHeader) {
                        throw new Error('acceptHeader must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let decodedAttachmentUrl = utils.customDecodeUri(attachmentUrl);

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.getConversationAttachment(
                        conversationId,
                        decodedAttachmentUrl,
                        acceptHeader,
                        metadata);
                    return result;
                },

                deleteConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.deleteConversation(conversationId, metadata);
                },

                deleteConversationEvent: async function (conversationId, eventId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!eventId) {
                        throw new Error('eventId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.deleteConversationEvent(
                        conversationId,
                        eventId,
                        metadata);
                },

                starConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.starConversation(
                        conversationId,
                        metadata);
                },

                unstarConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.unstarConversation(
                        conversationId,
                        metadata);
                },

                archiveConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.archiveConversation(
                        conversationId,
                        metadata);
                },

                unarchiveConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.unarchiveConversation(
                        conversationId,
                        metadata);
                },

                moveConversationToOtherMailbox: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.moveConversationToOtherMailbox(
                        conversationId,
                        metadata);
                },

                moveConversationToFocusedMailbox: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.moveConversationToFocusedMailbox(
                        conversationId,
                        metadata);
                },

                readConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.readConversation(
                        conversationId,
                        metadata);
                },

                unreadConversation: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.unreadConversation(
                        conversationId,
                        metadata);
                },

                changeConversationEvent: async function (conversationId, eventId, text, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!eventId) {
                        throw new Error('eventId must be defined');
                    }

                    if (!text) {
                        throw new Error('text must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.changeConversationEvent(
                        conversationId,
                        eventId,
                        text,
                        metadata);
                    return result;
                },

                createConversationEvent: async function (conversationId, text, attachments, replyTo, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!text && !attachments) {
                        throw new Error('text or attachments must be defined');
                    }

                    if (!attachments) {
                        attachments = [];
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.createConversationEvent(
                        conversationId,
                        text,
                        attachments,
                        replyTo,
                        metadata);
                    return result;
                },

                uploadConversationAttachment: async function (conversationId, attachment, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!attachment) {
                        throw new Error('attachment must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.uploadConversationAttachment(
                        conversationId,
                        attachment,
                        metadata);
                    return result;
                },

                addConversationEventReaction: async function (conversationId, eventId, emoji, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!eventId) {
                        throw new Error('eventId must be defined');
                    }

                    if (!emoji) {
                        throw new Error('emoji must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.addConversationEventReaction(
                        conversationId,
                        eventId,
                        emoji,
                        metadata);
                },

                revokeConversationEventReaction: async function (conversationId, eventId, emoji, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!eventId) {
                        throw new Error('eventId must be defined');
                    }

                    if (!emoji) {
                        throw new Error('emoji must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    await connector.linkedIn.conversations.revokeConversationEventReaction(
                        conversationId,
                        eventId,
                        emoji,
                        metadata);
                },

                getConversationParticipants: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.getConversationParticipants(
                        conversationId,
                        metadata);
                    return result;
                },

                getConversationSeenReceipts: async function (conversationId, metadata) {
                    if (!conversationId) {
                        throw new Error('conversationId must be defined');
                    }

                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.conversations.getConversationSeenReceipts(
                        conversationId,
                        metadata);
                    return result;
                },
            },

            contacts: {

                getContactFullProfile: async function (entityId, metadata) {
                    if (!metadata) {
                        metadata = _correlationFactory();
                    }

                    let connector = getConnector(metadata);
                    let result = await connector.linkedIn.contacts.getContactFullProfile(entityId, metadata);
                    return result;
                }
            }

        },

        api: {

            getLinkedInProfiles: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).api.getLinkedInProfiles(metadata);
                return result;
            },

            addLinkedInProfile: async function (profile, metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).api.addLinkedInProfile(profile, metadata);
                return result;
            },

            isCompatibleWithCurrentExtension: async function (metadata) {
                if (!metadata) {
                    metadata = _correlationFactory();
                }

                let result = await getConnector(metadata).api.isCompatibleWithCurrentExtension(metadata);
                return result;
            }
        },

        extension: {

            isInstalled: function (metadata) {
                let connector = null;
                try {
                    connector = getConnector(metadata);
                } catch (exp) {
                    if (!(exp.name === "ExtensionNotInstalledError")) {
                        throw exp;
                    }
                }

                let result = !!connector;
                return result;
            }

        },

        utils: {

            createMetadata: function () {
                const result = _correlationFactory();
                return result;
            }

        },

        eventHandlers: {

            suppressEvents: function (metadata) {
                getConnector(metadata).eventHandlers.suppressEvents();
            },

            enableEvents: function (metadata) {
                getConnector(metadata).eventHandlers.enableEvents();
            },

            addLinkedInSignedOutEventHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addLinkedInSignedOutEventHandler(handler);
            },

            addLinkedInProfileDetectedHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addLinkedInProfileDetectedHandler(handler);
            },

            addSnailySignedInEventHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addSnailySignedInEventHandler(handler);
            },

            addSnailySignedOutEventHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addSnailySignedOutEventHandler(handler);
            },

            addSnailyProfileChangedEventHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addSnailyProfileChangedEventHandler(handler);
            },

            addAutomationEndedEventHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addAutomationEndedEventHandler(handler);
            },

            removeAutomationEndedEventHandlers: function (metadata) {
                getConnector(metadata).eventHandlers.removeAutomationEndedEventHandlers();
            },

            addWorkingHoursChangedHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.addWorkingHoursChangedHandler(handler);
            },

            removeWorkingHoursChangedHandler: function (handler, metadata) {
                getConnector(metadata).eventHandlers.removeWorkingHoursChangedHandler(handler);
            },

        },

        init: async function (metadata) {
            if (!metadata) {
                metadata = metadataFactory.create();
            }

            _correlationFactory = metadataFactory.create;
            let connector = backendConnectorFactory();
            await connector.init();
            setConnector(connector);
        }

    };

    return factory;

};

export { connectorFactory };
